import * as i0 from '@angular/core';
import { InjectionToken, inject, Injectable, signal, computed, Component, Input, Pipe, Inject, ViewChild, EventEmitter, Output, SecurityContext, DestroyRef, Injector, effect, ViewChildren, ViewEncapsulation, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i2$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import { map, shareReplay, catchError, of, forkJoin, fromEvent, Subject, timer, takeUntil, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as i2$2 from '@garmin-avcloud/avcloud-fly-web-common/shared';
import { GarminGlobalStoreService, FeatureFlyGarmin } from '@garmin-avcloud/avcloud-fly-web-common/shared';
import * as i1$1 from '@angular/common/http';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import * as i1 from '@angular/platform-browser';
import { createCustomElement } from '@angular/elements';
function HeaderLogoComponent_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderLogoComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 3);
    i0.ɵɵtemplate(2, HeaderLogoComponent_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const logo_r2 = i0.ɵɵreference(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", ctx_r0.link, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", ctx_r0.linkDescription);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", logo_r2);
  }
}
function HeaderLogoComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 5)(1, "img", 6);
  }
}
const _c0 = ["container"];
const _c1 = ["button"];
const _c2 = ["menu"];
const _c3 = a0 => ({
  link: a0,
  useLinkClass: false,
  useTextClass: true
});
const _c4 = a0 => ({
  link: a0
});
const _c5 = (a0, a1) => ({
  "link": a0,
  "text": a1
});
function HeaderNavAreaComponent_div_7_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", category_r2.name, " ");
  }
}
function HeaderNavAreaComponent_div_7_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r3 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const linkTemplate_r4 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", linkTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c4, link_r3));
  }
}
function HeaderNavAreaComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵtemplate(1, HeaderNavAreaComponent_div_7_span_1_Template, 2, 1, "span", 12)(2, HeaderNavAreaComponent_div_7_div_2_Template, 2, 4, "div", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r2 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", category_r2.name != null);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r2.links);
  }
}
function HeaderNavAreaComponent_ng_template_8_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function HeaderNavAreaComponent_ng_template_8_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const link_r6 = ctx_r4.link;
    const useLinkClass_r7 = ctx_r4.useLinkClass;
    const useTextClass_r8 = ctx_r4.useTextClass;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c5, useLinkClass_r7 !== false, useTextClass_r8 === true))("routerLink", link_r6.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r6.name, " ");
  }
}
function HeaderNavAreaComponent_ng_template_8_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵpipe(1, "flyHrefLink");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    const link_r6 = ctx_r4.link;
    const useLinkClass_r7 = ctx_r4.useLinkClass;
    const useTextClass_r8 = ctx_r4.useTextClass;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c5, useLinkClass_r7 !== false, useTextClass_r8 === true))("href", i0.ɵɵpipeBind1(1, 3, link_r6), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", link_r6.name, " ");
  }
}
function HeaderNavAreaComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderNavAreaComponent_ng_template_8_ng_container_0_Template, 1, 0, "ng-container", 15)(1, HeaderNavAreaComponent_ng_template_8_ng_template_1_Template, 2, 6, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(3, HeaderNavAreaComponent_ng_template_8_ng_template_3_Template, 3, 8, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const link_r6 = ctx.link;
    const useRouterLink_r9 = i0.ɵɵreference(2);
    const useHrefLink_r10 = i0.ɵɵreference(4);
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", link_r6.site === "FG" && ctx_r10.ssoClientId === "FLY_GARMIN_APP")("ngIfThen", useRouterLink_r9)("ngIfElse", useHrefLink_r10);
  }
}
function HeaderNavComponent_fly_header_nav_area_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-header-nav-area", 1);
  }
  if (rf & 2) {
    const area_r1 = ctx.$implicit;
    i0.ɵɵproperty("area", area_r1);
  }
}
const _c6 = ["skipButton"];
const _c7 = ["*", [["", 8, "nav-menu-content"]]];
const _c8 = ["*", ".nav-menu-content"];
const _c9 = ["skipLink"];
function HeaderUtilityBarComponent_a_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16, 0);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵelementStart(3, "span", 18);
    i0.ɵɵtext(4, " Support ");
    i0.ɵɵelementEnd()();
  }
}
function HeaderUtilityBarComponent_section_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 19)(1, "header");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.customer.name);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.customer.email);
  }
}
function HeaderUtilityBarComponent_section_8_p_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("My Profile ", ctx_r0.customerFirstName === "" ? "" : "(" + ctx_r0.customerFirstName + ")", "");
  }
}
function HeaderUtilityBarComponent_section_8_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.headerConfigurationService.orgName());
  }
}
function HeaderUtilityBarComponent_section_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 21)(1, "header");
    i0.ɵɵtext(2, "SELECTED PROFILE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 22);
    i0.ɵɵtemplate(4, HeaderUtilityBarComponent_section_8_p_4_Template, 2, 1, "p", 23)(5, HeaderUtilityBarComponent_section_8_ng_template_5_Template, 2, 1, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(7, "button", 24);
    i0.ɵɵlistener("click", function HeaderUtilityBarComponent_section_8_Template_button_click_7_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClickChangeProfileButton());
    });
    i0.ɵɵtext(8, "Change Profile");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const orgDisplay_r3 = i0.ɵɵreference(6);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.headerConfigurationService.orgName() === "")("ngIfElse", orgDisplay_r3);
  }
}
function HeaderUtilityBarComponent_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵlistener("click", function HeaderUtilityBarComponent_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClickAccountButton());
    });
    i0.ɵɵtext(1, " Account ");
    i0.ɵɵelementEnd();
  }
}
function HeaderUtilityBarComponent_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HeaderUtilityBarComponent_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClickSignOutButton());
    });
    i0.ɵɵtext(1, " Sign Out ");
    i0.ɵɵelementEnd();
  }
}
function HeaderUtilityBarComponent_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵlistener("click", function HeaderUtilityBarComponent_button_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onClickSignInButton());
    });
    i0.ɵɵtext(1, " Sign In ");
    i0.ɵɵelementEnd();
  }
}
function HeaderUtilityBarComponent_a_14_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.headerCartService.cartItemQuantity());
  }
}
function HeaderUtilityBarComponent_a_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 26, 0);
    i0.ɵɵtemplate(2, HeaderUtilityBarComponent_a_14_Conditional_2_Template, 2, 1, "span", 27);
    i0.ɵɵelement(3, "img", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.headerCartService.cartItemQuantity() != null ? 2 : -1);
  }
}
function HeaderUtilityBarComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 29, 0);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵelementStart(3, "span", 18);
    i0.ɵɵtext(4, " Support ");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.supportUrl, i0.ɵɵsanitizeUrl);
  }
}
function HeaderUtilityBarComponent_ng_template_17_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.headerCartService.cartItemQuantity());
  }
}
function HeaderUtilityBarComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 30, 0);
    i0.ɵɵtemplate(2, HeaderUtilityBarComponent_ng_template_17_Conditional_2_Template, 2, 1, "span", 27);
    i0.ɵɵelement(3, "img", 28);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("href", ctx_r0.cartUrl, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.headerCartService.cartItemQuantity() != null ? 2 : -1);
  }
}
function MobileNavOpenComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 4)(1, "g", 5)(2, "g", 6);
    i0.ɵɵelement(3, "polygon", 7);
    i0.ɵɵelementEnd()()();
  }
}
function MobileNavOpenComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8)(1, "style");
    i0.ɵɵtext(2, "tspan{white-space:pre}.shp0{fill:#000}");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "path", 9);
    i0.ɵɵelementEnd();
  }
}
function MobileNavOpenComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const plus_r1 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", plus_r1);
  }
}
function MobileNavOpenComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 10);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const minus_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", minus_r2);
  }
}
function MobileNavSubcategoryComponent_div_5_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MobileNavSubcategoryComponent_div_5_ng_container_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", link_r1.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r1.name, " ");
  }
}
function MobileNavSubcategoryComponent_div_5_ng_container_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 10);
    i0.ɵɵpipe(1, "flyHrefLink");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", i0.ɵɵpipeBind1(1, 2, link_r1), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", link_r1.name, " ");
  }
}
function MobileNavSubcategoryComponent_div_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MobileNavSubcategoryComponent_div_5_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 8)(2, MobileNavSubcategoryComponent_div_5_ng_container_1_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, MobileNavSubcategoryComponent_div_5_ng_container_1_ng_template_4_Template, 3, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const link_r1 = ctx.$implicit;
    const useRouterLink_r2 = i0.ɵɵreference(3);
    const useHrefLink_r3 = i0.ɵɵreference(5);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r1.site === "FG" && ctx_r3.ssoClientId === "FLY_GARMIN_APP")("ngIfThen", useRouterLink_r2)("ngIfElse", useHrefLink_r3);
  }
}
function MobileNavSubcategoryComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, MobileNavSubcategoryComponent_div_5_ng_container_1_Template, 6, 3, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.category.links);
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "fly-mobile-nav-subcategory", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("category", category_r1);
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", link_r2.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r2.name, " ");
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵpipe(1, "flyHrefLink");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", i0.ɵɵpipeBind1(1, 2, link_r2), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", link_r2.name, " ");
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_ng_container_1_Template, 1, 0, "ng-container", 13)(2, MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_ng_template_4_Template, 3, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r2 = ctx.$implicit;
    const useRouterLink_r3 = i0.ɵɵreference(3);
    const useHrefLink_r4 = i0.ɵɵreference(5);
    const ctx_r4 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r2.site === "FG" && ctx_r4.ssoClientId === "FLY_GARMIN_APP")("ngIfThen", useRouterLink_r3)("ngIfElse", useHrefLink_r4);
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MobileNavCategoryComponent_ng_container_6_div_1_div_2_div_1_Template, 6, 3, "div", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", category_r1.links);
  }
}
function MobileNavCategoryComponent_ng_container_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, MobileNavCategoryComponent_ng_container_6_div_1_div_1_Template, 2, 1, "div", 10)(2, MobileNavCategoryComponent_ng_container_6_div_1_div_2_Template, 2, 1, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.area.categories.length > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.area.categories.length === 1);
  }
}
function MobileNavCategoryComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 7);
    i0.ɵɵtemplate(1, MobileNavCategoryComponent_ng_container_6_div_1_Template, 3, 2, "div", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r4.area.categories);
  }
}
function MobileNavComponent_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "fly-mobile-nav-category", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const area_r1 = ctx.$implicit;
    const id_r2 = ctx.index;
    i0.ɵɵadvance();
    i0.ɵɵproperty("area", area_r1)("enableTopBorder", id_r2 !== 0);
  }
}
const _c10 = ["hamburgerMenu"];
function MobileNavIconComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "fly-mobile-nav");
    i0.ɵɵelementEnd();
  }
}
const _c11 = ["utilityBar"];
function FooterCategoryComponent_ul_0_li_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function FooterCategoryComponent_ul_0_li_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", link_r1.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r1.name, " ");
  }
}
function FooterCategoryComponent_ul_0_li_3_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 8);
    i0.ɵɵpipe(1, "flyHrefLink");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", i0.ɵɵpipeBind1(1, 2, link_r1), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", link_r1.name, " ");
  }
}
function FooterCategoryComponent_ul_0_li_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵtemplate(1, FooterCategoryComponent_ul_0_li_3_ng_container_1_Template, 1, 0, "ng-container", 6)(2, FooterCategoryComponent_ul_0_li_3_ng_template_2_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(4, FooterCategoryComponent_ul_0_li_3_ng_template_4_Template, 3, 4, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r1 = ctx.$implicit;
    const useRouterLink_r2 = i0.ɵɵreference(3);
    const useHrefLink_r3 = i0.ɵɵreference(5);
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r1.site === "FG" && ctx_r3.ssoClientId === "FLY_GARMIN_APP")("ngIfThen", useRouterLink_r2)("ngIfElse", useHrefLink_r3);
  }
}
function FooterCategoryComponent_ul_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 3)(1, "li", 4);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, FooterCategoryComponent_ul_0_li_3_Template, 6, 3, "li", 5);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r3.category.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.category.links);
  }
}
function MobileFooterCategoryComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 9);
    i0.ɵɵelement(1, "path", 10);
    i0.ɵɵelementEnd();
  }
}
function MobileFooterCategoryComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 11);
    i0.ɵɵelement(1, "path", 12);
    i0.ɵɵelementEnd();
  }
}
function MobileFooterCategoryComponent_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const down_r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("ngTemplateOutlet", down_r2);
  }
}
function MobileFooterCategoryComponent_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0, 13);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const up_r3 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngTemplateOutlet", up_r3);
  }
}
function MobileFooterCategoryComponent_ng_container_10_div_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MobileFooterCategoryComponent_ng_container_10_div_1_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", link_r4.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r4.name, " ");
  }
}
function MobileFooterCategoryComponent_ng_container_10_div_1_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 18);
    i0.ɵɵpipe(1, "flyHrefLink");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", i0.ɵɵpipeBind1(1, 2, link_r4), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", link_r4.name, " ");
  }
}
function MobileFooterCategoryComponent_ng_container_10_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MobileFooterCategoryComponent_ng_container_10_div_1_ng_container_1_Template, 1, 0, "ng-container", 16)(2, MobileFooterCategoryComponent_ng_container_10_div_1_ng_template_2_Template, 2, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(4, MobileFooterCategoryComponent_ng_container_10_div_1_ng_template_4_Template, 3, 4, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r4 = ctx.$implicit;
    const useRouterLink_r5 = i0.ɵɵreference(3);
    const useHrefLink_r6 = i0.ɵɵreference(5);
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", link_r4.site === "FG" && ctx_r6.ssoClientId === "FLY_GARMIN_APP")("ngIfThen", useRouterLink_r5)("ngIfElse", useHrefLink_r6);
  }
}
function MobileFooterCategoryComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 14);
    i0.ɵɵtemplate(1, MobileFooterCategoryComponent_ng_container_10_div_1_Template, 6, 3, "div", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r6.category == null ? null : ctx_r6.category.links);
  }
}
function FooterComponent_fly_footer_category_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-footer-category", 11);
  }
  if (rf & 2) {
    const category_r1 = ctx.$implicit;
    i0.ɵɵproperty("category", category_r1);
  }
}
function FooterComponent_fly_mobile_footer_category_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "fly-mobile-footer-category", 11);
  }
  if (rf & 2) {
    const category_r2 = ctx.$implicit;
    i0.ɵɵproperty("category", category_r2);
  }
}
function FooterComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "a", 13);
    i0.ɵɵlistener("click", function FooterComponent_div_5_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.changeLocale());
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.localeName, " ");
  }
}
function FooterComponent_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 14);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r3.flyGarminVersion, i0.ɵɵsanitizeHtml);
  }
}
const FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN = new InjectionToken('FlyGarminAppNavigationConfig');
const CONTEXT_ID_HEADER = 'X-garmin-context-uuid';
let FeatureService = /*#__PURE__*/(() => {
  class FeatureService {
    constructor() {
      this.config = inject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN);
      this.http = inject(HttpClient);
      this.globalStorageService = inject(GarminGlobalStoreService);
      this.SERVICE_PATH = 'api/v2/feature-flags';
      this.url = `${this.config.flyLegacyUrl}${this.SERVICE_PATH}`;
      this.features = null;
    }
    isFeatureActive(feature) {
      if (this.features == null) {
        this.features = this.getFeatures();
      }
      return this.features.pipe(map(response => {
        return response?.get(feature) ?? false;
      }));
    }
    getFeatures() {
      const allFeatures = Object.values(FeatureFlyGarmin).join(',');
      const httpParams = new HttpParams().set('featureFlagNames', allFeatures);
      let httpHeaders = new HttpHeaders();
      // We only need to set the org header here if the consumer is webapp since
      // the FG interceptor will add it when it's the consumer.
      if (this.config.ssoClientId === 'FLY_GARMIN') {
        const organizationUuid = this.globalStorageService.getGlobal('org.uuid');
        if (organizationUuid != null && organizationUuid !== '') {
          httpHeaders = httpHeaders.set(CONTEXT_ID_HEADER, organizationUuid);
        }
      }
      return this.http.get(`${this.url}`, {
        params: httpParams,
        headers: httpHeaders
      }).pipe(shareReplay(1), map(response => {
        const featureMap = new Map();
        response.forEach(featureFlag => {
          featureMap.set(featureFlag.feature, featureFlag.enabled);
        });
        return featureMap;
      }), catchError(() => of(null)));
    }
    static {
      this.ɵfac = function FeatureService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FeatureService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FeatureService,
        factory: FeatureService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FeatureService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
  Move these categories back to the devices top-level navigation once the new aircraft list page feature flag
  is removed. Extracting these categories allows us to limit the amount of duplication required due to the
  way the FeatureSet checks are designed.
*/
const DEVICES_CATEGORIES = [{
  name: 'Device Management',
  links: [{
    name: 'Overview',
    link: 'devices/overview',
    site: 'FLY'
  }, {
    name: 'Devices',
    link: 'devices/list',
    site: 'FLY',
    isOldAircraftListPageFeature: true
  }, {
    name: 'Devices',
    link: 'aircraft/list',
    site: 'FG',
    isNewAircraftListPageFeature: true
  }, {
    name: 'Manage Dealer Access',
    link: 'devices/dealer-access-management',
    site: 'FLY'
  }]
}, {
  name: 'Warranty',
  links: [{
    name: 'Warranty',
    link: 'devices/warranty-registration',
    site: 'FLY'
  }]
}, {
  name: 'Transfers',
  isDealerOrOemFeature: true,
  links: [{
    name: 'Transfer Aircraft',
    link: 'devices/transfer',
    site: 'FLY'
  }]
}];
const AREAS = [{
  name: 'OEM',
  isOemFeature: true,
  link: 'oem/install-databases',
  site: 'FLY',
  categories: [{
    name: 'OEM',
    links: [{
      name: 'Install Databases',
      link: 'oem/install-databases',
      site: 'FLY'
    }]
  }, {
    name: 'Installation and Test Tools',
    isOrgFeature: true,
    isGifdFeature: true,
    links: [{
      name: 'Software & Enablements',
      link: 'gifd/download',
      site: 'FG'
    }, {
      name: 'Digital File Signing',
      link: 'gifd/upload',
      site: 'FG'
    }, {
      name: 'Download Previous Files',
      link: 'gifd/file-download',
      site: 'FG'
    }]
  }]
}, {
  name: 'Dealer',
  isDealerFeature: true,
  link: 'dealer/customer-management/',
  site: 'FLY',
  categories: [{
    name: 'Dealer',
    links: [{
      name: 'Manage Customer Aircraft and Devices',
      link: 'dealer/customer-management/',
      site: 'FLY'
    }, {
      name: 'Feature Enablements',
      link: 'dealer/enablements/',
      site: 'FLY'
    }, {
      name: 'Install Databases',
      link: 'dealer/install/',
      site: 'FLY'
    }, {
      name: 'Warranty Registration',
      link: 'dealer/warranty-registration/',
      site: 'FLY'
    }]
  }]
},
/*
  Consolidate these devices links once the new aircraft list page feature flag is removed. Unfortunately, there
  is no way to do this without some duplication because of the way the FeatureSet checks are designed.
*/
{
  name: 'Devices',
  link: 'devices/list',
  site: 'FLY',
  isOldAircraftListPageFeature: true,
  categories: DEVICES_CATEGORIES
}, {
  name: 'Devices',
  link: 'aircraft/list',
  site: 'FG',
  isNewAircraftListPageFeature: true,
  categories: DEVICES_CATEGORIES
}, {
  name: 'Subscriptions',
  link: 'subscriptions',
  site: 'FG',
  categories: [{
    name: 'Databases',
    links: [{
      name: 'Buy Databases',
      link: 'devices/database-pricing',
      site: 'FLY'
    }, {
      name: 'Manage Subscriptions',
      link: 'subscriptions/databases',
      site: 'FG',
      isCustomerFeature: true
    }, {
      name: 'Update Schedule',
      link: 'devices/update-schedule',
      site: 'FLY'
    }]
  }, {
    name: 'Garmin Pilot',
    links: [{
      name: 'Overview',
      link: 'garmin-pilot/',
      site: 'FLY',
      isLoggedOutCustomerFeature: true
    }, {
      name: 'Subscriptions',
      link: 'subscriptions/garmin-pilot',
      site: 'FG',
      isCustomerFeature: true,
      isGpAutoRenewalFeature: true
    }, {
      name: 'Purchases',
      link: 'garmin-pilot/purchases/',
      site: 'FLY',
      isCustomerFeature: true
    }, {
      name: 'Catalog',
      link: 'garmin-pilot/catalog/',
      site: 'FLY',
      isCustomerFeature: true
    }]
  }, {
    name: 'Services',
    links: [{
      name: 'Connected-Cockpit Services',
      link: 'connext/satellite-services/',
      site: 'FLY'
    }]
  }]
}, {
  name: 'Logbook',
  link: 'logbook/#/list',
  site: 'FLY',
  categories: [{
    name: 'Aircraft Logbook',
    isLogbookFeature: true,
    links: [{
      name: 'Aircraft',
      link: 'aircraft-logbook',
      site: 'FG'
    }, {
      name: 'Upload',
      link: 'aircraft-logbook/upload',
      site: 'FG',
      isLogbookUploadFeature: true
    }, {
      name: 'Sharing',
      link: 'aircraft-logbook/sharing',
      site: 'FG',
      isLogbookSharingFeature: true
    }]
  }, {
    name: 'Pilot Logbook',
    links: [{
      name: 'Entries',
      link: 'logbook/#/list',
      site: 'FLY'
    }, {
      name: 'Currency and Alerts',
      link: 'logbook/#/currency',
      site: 'FLY'
    }, {
      name: 'Reports',
      link: 'logbook/#/reports',
      site: 'FLY'
    }, {
      name: 'Endorsements',
      link: 'logbook/#/endorsements',
      site: 'FLY'
    }]
  }, {
    name: 'Pilot Setup',
    links: [{
      name: 'Setup',
      link: 'logbook/#/setup',
      site: 'FLY'
    }, {
      name: 'Import',
      link: 'logbook/#/setup/import',
      site: 'FLY'
    }, {
      name: 'Export',
      link: 'logbook/#/setup/export',
      site: 'FLY'
    }]
  }]
}, {
  name: 'Training',
  link: 'training/',
  site: 'FLY',
  categories: [{
    name: 'Training',
    links: [{
      name: 'Overview',
      link: 'training/',
      site: 'FLY'
    }]
  }]
}, {
  name: 'Organization',
  isOrgFeature: true,
  link: 'org',
  site: 'FG',
  categories: [{
    name: 'Organization',
    links: [{
      name: 'Members',
      link: 'org/members',
      site: 'FG'
    }, {
      name: 'Aircraft',
      link: 'devices/list',
      site: 'FLY',
      isOldAircraftListPageFeature: true
    }, {
      name: 'Aircraft',
      link: 'aircraft/list',
      site: 'FG',
      isNewAircraftListPageFeature: true
    }, {
      name: 'Roles',
      link: 'org/roles',
      site: 'FG',
      isCustomRolesFeature: true
    }]
  }]
}];
let HeaderConfigurationService = /*#__PURE__*/(() => {
  class HeaderConfigurationService {
    constructor() {
      this.featureService = inject(FeatureService);
      this.gifdEnabled = signal(false);
      this.gpAutoRenewalEnabled = signal(false);
      this.orgsEnabled = signal(false);
      this.customRolesEnabled = signal(false);
      this.logbooksEnabled = signal(false);
      this.logbookUploadEnabled = signal(false);
      this.logbookSharingEnabled = signal(false);
      this.newAircraftListPageEnabled = signal(false);
      this.isDealer = signal(false);
      this.isOem = signal(false);
      this.isCustomer = signal(false);
      this.orgName = signal('');
      this.areas = computed(() => {
        return AREAS.reduce((A, area) => {
          if (this.showFeatureSet(area)) {
            const categories = area.categories.reduce((C, category) => {
              if (this.showFeatureSet(category)) {
                const links = category.links.filter(link => this.showFeatureSet(link));
                C.push({
                  ...category,
                  links
                });
              }
              return C;
            }, []);
            A.push({
              ...area,
              categories
            });
          }
          return A;
        }, []);
      });
      forkJoin([this.featureService.isFeatureActive(FeatureFlyGarmin.GP_AUTO_RENEWALS), this.featureService.isFeatureActive(FeatureFlyGarmin.HYDRA), this.featureService.isFeatureActive(FeatureFlyGarmin.ORGS_ROLES), this.featureService.isFeatureActive(FeatureFlyGarmin.CUSTOM_ROLES), this.featureService.isFeatureActive(FeatureFlyGarmin.AIRCRAFT_LOGBOOK), this.featureService.isFeatureActive(FeatureFlyGarmin.AIRCRAFT_LOGBOOK_UPLOAD), this.featureService.isFeatureActive(FeatureFlyGarmin.ENABLE_FLIGHT_LOG_SHARING), this.featureService.isFeatureActive(FeatureFlyGarmin.ENABLE_NEW_AIRCRAFT_LIST_PAGE)]).pipe(takeUntilDestroyed()).subscribe({
        error: () => console.error('unable to get feature flags'),
        next: ([gpAutoRenewal, gifd, orgs, customRoles, logbook, logbookUpload, logbookSharing, aircraftList]) => {
          this.gpAutoRenewalEnabled.set(gpAutoRenewal);
          this.gifdEnabled.set(gifd);
          this.orgsEnabled.set(orgs);
          this.customRolesEnabled.set(customRoles);
          this.logbooksEnabled.set(logbook);
          this.logbookUploadEnabled.set(logbookUpload);
          this.logbookSharingEnabled.set(logbookSharing);
          this.newAircraftListPageEnabled.set(aircraftList);
        }
      });
    }
    init(isDealer, isOem, isCustomer, orgName) {
      this.isDealer.set(isDealer);
      this.isOem.set(isOem);
      this.isCustomer.set(isCustomer);
      this.orgName.set(orgName ?? '');
    }
    showFeatureSet(featureSet) {
      const conditions = [{
        condition: featureSet.isCustomerFeature,
        check: this.isCustomer()
      }, {
        condition: featureSet.isCustomRolesFeature,
        check: this.customRolesEnabled()
      }, {
        condition: featureSet.isLoggedOutCustomerFeature,
        check: !this.isCustomer()
      }, {
        condition: featureSet.isDealerFeature,
        check: this.isDealer()
      }, {
        condition: featureSet.isOemFeature,
        check: this.isOem()
      }, {
        condition: featureSet.isDealerOrOemFeature,
        check: this.isDealer() || this.isOem()
      }, {
        condition: featureSet.isOrgFeature,
        check: this.orgName() !== '' && this.orgsEnabled()
      }, {
        condition: featureSet.isGifdFeature,
        check: this.gifdEnabled()
      }, {
        condition: featureSet.isGpAutoRenewalFeature,
        check: featureSet.isGpAutoRenewalFeature === this.gpAutoRenewalEnabled()
      }, {
        condition: featureSet.isLogbookFeature,
        check: this.logbooksEnabled()
      }, {
        condition: featureSet.isLogbookUploadFeature,
        check: this.logbookUploadEnabled()
      }, {
        condition: featureSet.isLogbookSharingFeature,
        check: this.logbookSharingEnabled()
      }, {
        condition: featureSet.isNewAircraftListPageFeature,
        check: this.newAircraftListPageEnabled() && this.isCustomer()
      }, {
        condition: featureSet.isOldAircraftListPageFeature,
        check: !(this.newAircraftListPageEnabled() && this.isCustomer())
      }];
      return conditions.every(({
        condition,
        check
      }) => condition !== true || check);
    }
    static {
      this.ɵfac = function HeaderConfigurationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderConfigurationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HeaderConfigurationService,
        factory: HeaderConfigurationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HeaderConfigurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderLogoComponent = /*#__PURE__*/(() => {
  class HeaderLogoComponent {
    constructor() {
      this.enableLink = true;
      this.link = '/';
      this.linkDescription = 'Navigate to FlyGarmin.com';
    }
    static {
      this.ɵfac = function HeaderLogoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderLogoComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderLogoComponent,
        selectors: [["fly-header-logo"]],
        inputs: {
          enableLink: "enableLink",
          link: "link",
          linkDescription: "linkDescription"
        },
        standalone: false,
        decls: 4,
        vars: 2,
        consts: [["logo", ""], [1, "container"], [4, "ngIf", "ngIfElse"], [3, "href"], [4, "ngTemplateOutlet"], ["alt", "FlyGarmin", "src", "https://static.garmincdn.com/apps/fly/img/logos/garmin-flygarmin-logo.svg", 1, "flygarmin-logo"], ["alt", "FlyGarmin", "src", "https://static.garmincdn.com/apps/fly/img/logos/flygarmin-mobile.svg", 1, "flygarmin-logo-mobile"]],
        template: function HeaderLogoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, HeaderLogoComponent_ng_container_1_Template, 3, 3, "ng-container", 2)(2, HeaderLogoComponent_ng_template_2_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            const logo_r2 = i0.ɵɵreference(3);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.enableLink)("ngIfElse", logo_r2);
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet],
        styles: [".container[_ngcontent-%COMP%]{align-items:center}@media screen and (max-width: 1200px){.container[_ngcontent-%COMP%]{border-bottom:#666}}.container[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{display:flex}@media screen and (max-width: 1200px){.container[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-height:4.5rem}}@media screen and (max-width: 1024px){.container[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{min-height:3.125rem}}.logo-divider[_ngcontent-%COMP%]{background-color:#666;height:1.75rem;min-width:.1rem;margin:auto 1.5rem}.flygarmin-logo-mobile[_ngcontent-%COMP%]{display:none}@media screen and (max-width: 768px){.flygarmin-logo-mobile[_ngcontent-%COMP%]{display:revert}}@media screen and (max-width: 768px){.flygarmin-logo[_ngcontent-%COMP%]{display:none}}"]
      });
    }
  }
  return HeaderLogoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HrefLinkPipe = /*#__PURE__*/(() => {
  class HrefLinkPipe {
    constructor(config, document) {
      this.config = config;
      this.document = document;
      this.localhost = 'localhost.garmin.com';
    }
    transform(link) {
      if (link.site === 'FLY') {
        if (this.document.location.hostname === this.localhost) {
          return `https://${this.localhost}:8443/fly-garmin/${link.link}`;
        }
        return this.config.flyLegacyUrl + link.link;
      } else if (link.site === 'FG') {
        return this.config.fgUrl + link.link;
      } else {
        return link.link;
      }
    }
    static {
      this.ɵfac = function HrefLinkPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HrefLinkPipe)(i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN, 16), i0.ɵɵdirectiveInject(DOCUMENT, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "flyHrefLink",
        type: HrefLinkPipe,
        pure: true,
        standalone: false
      });
    }
  }
  return HrefLinkPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderNavAreaComponent = /*#__PURE__*/(() => {
  class HeaderNavAreaComponent {
    constructor(headerConfigurationService, config) {
      this.headerConfigurationService = headerConfigurationService;
      this.config = config;
      this.ssoClientId = '';
      this.ssoClientId = config.ssoClientId;
    }
    onFocusOut(event) {
      const newFocus = event.relatedTarget;
      if (newFocus == null) {
        this.removeClass();
        return;
      }
      let parent = newFocus.parentElement;
      let found = false;
      while (parent != null) {
        if (parent === this.container.nativeElement) {
          found = true;
        }
        parent = parent.parentElement;
      }
      if (!found) {
        this.removeClass();
      }
    }
    onKeyPress(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.addClass();
        this.menu.nativeElement.querySelector('a')?.focus();
      }
    }
    onMouseEnter() {
      this.addClass();
    }
    onMouseLeave() {
      this.removeClass();
    }
    addClass() {
      this.container.nativeElement.classList.add('container--active');
      this.menu.nativeElement.classList.add('menu--active');
    }
    removeClass() {
      this.container.nativeElement.classList.remove('container--active');
      this.menu.nativeElement.classList.remove('menu--active');
    }
    static {
      this.ɵfac = function HeaderNavAreaComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderNavAreaComponent)(i0.ɵɵdirectiveInject(HeaderConfigurationService), i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNavAreaComponent,
        selectors: [["fly-header-nav-area"]],
        viewQuery: function HeaderNavAreaComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menu = _t.first);
          }
        },
        inputs: {
          area: "area"
        },
        standalone: false,
        decls: 10,
        vars: 5,
        consts: [["container", ""], ["button", ""], ["menu", ""], ["linkTemplate", ""], ["useRouterLink", ""], ["useHrefLink", ""], [1, "container", 3, "mouseenter", "mouseleave", "focusout"], [1, "area-button", 3, "keypress"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "menu"], ["class", "column", 4, "ngFor", "ngForOf"], [1, "column"], ["class", "category-heading", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "category-heading"], [4, "ngIf", "ngIfThen", "ngIfElse"], [3, "ngClass", "routerLink"], [3, "ngClass", "href"]],
        template: function HeaderNavAreaComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 6, 0);
            i0.ɵɵlistener("mouseenter", function HeaderNavAreaComponent_Template_div_mouseenter_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onMouseEnter());
            })("mouseleave", function HeaderNavAreaComponent_Template_div_mouseleave_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onMouseLeave());
            })("focusout", function HeaderNavAreaComponent_Template_div_focusout_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusOut($event));
            });
            i0.ɵɵelementStart(2, "li", 7, 1);
            i0.ɵɵlistener("keypress", function HeaderNavAreaComponent_Template_li_keypress_2_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onKeyPress($event));
            });
            i0.ɵɵelementContainer(4, 8);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 9, 2);
            i0.ɵɵtemplate(7, HeaderNavAreaComponent_div_7_Template, 3, 2, "div", 10);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, HeaderNavAreaComponent_ng_template_8_Template, 5, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const linkTemplate_r4 = i0.ɵɵreference(9);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngTemplateOutlet", linkTemplate_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c3, ctx.area));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.area.categories);
          }
        },
        dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2$1.RouterLink, HrefLinkPipe],
        styles: ["body[_ngcontent-%COMP%]{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body[_ngcontent-%COMP%]{font-weight:400}.category-heading[_ngcontent-%COMP%], .text[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html[_ngcontent-%COMP%]{line-height:1.15;-webkit-text-size-adjust:100%}body[_ngcontent-%COMP%]{margin:0}main[_ngcontent-%COMP%]{display:block}h1[_ngcontent-%COMP%]{font-size:2em;margin:.67em 0}hr[_ngcontent-%COMP%]{box-sizing:content-box;height:0;overflow:visible}pre[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}a[_ngcontent-%COMP%]{background-color:transparent}abbr[title][_ngcontent-%COMP%]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b[_ngcontent-%COMP%], strong[_ngcontent-%COMP%]{font-weight:bolder}code[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], samp[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}small[_ngcontent-%COMP%]{font-size:80%}sub[_ngcontent-%COMP%], sup[_ngcontent-%COMP%]{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub[_ngcontent-%COMP%]{bottom:-.25em}sup[_ngcontent-%COMP%]{top:-.5em}img[_ngcontent-%COMP%]{border-style:none}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%], optgroup[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{overflow:visible}button[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{text-transform:none}button[_ngcontent-%COMP%], [type=button][_ngcontent-%COMP%], [type=reset][_ngcontent-%COMP%], [type=submit][_ngcontent-%COMP%]{-webkit-appearance:button}button[_ngcontent-%COMP%]::-moz-focus-inner, [type=button][_ngcontent-%COMP%]::-moz-focus-inner, [type=reset][_ngcontent-%COMP%]::-moz-focus-inner, [type=submit][_ngcontent-%COMP%]::-moz-focus-inner{border-style:none;padding:0}button[_ngcontent-%COMP%]:-moz-focusring, [type=button][_ngcontent-%COMP%]:-moz-focusring, [type=reset][_ngcontent-%COMP%]:-moz-focusring, [type=submit][_ngcontent-%COMP%]:-moz-focusring{outline:1px dotted ButtonText}fieldset[_ngcontent-%COMP%]{padding:.35em .75em .625em}legend[_ngcontent-%COMP%]{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress[_ngcontent-%COMP%]{vertical-align:baseline}textarea[_ngcontent-%COMP%]{overflow:auto}[type=checkbox][_ngcontent-%COMP%], [type=radio][_ngcontent-%COMP%]{box-sizing:border-box;padding:0}[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, [type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{height:auto}[type=search][_ngcontent-%COMP%]{-webkit-appearance:textfield;outline-offset:-2px}[type=search][_ngcontent-%COMP%]::-webkit-search-decoration{-webkit-appearance:none}[_ngcontent-%COMP%]::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details[_ngcontent-%COMP%]{display:block}summary[_ngcontent-%COMP%]{display:list-item}template[_ngcontent-%COMP%]{display:none}[hidden][_ngcontent-%COMP%]{display:none}code[_ngcontent-%COMP%]{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1[_ngcontent-%COMP%]{font-size:2.5rem}}h2[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2[_ngcontent-%COMP%]{font-size:2rem}}h3[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3[_ngcontent-%COMP%]{font-size:1.5rem}}h4[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4[_ngcontent-%COMP%]{font-size:1.25rem}}h5[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5[_ngcontent-%COMP%]{font-size:1rem}}h6[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6[_ngcontent-%COMP%]{font-size:1rem}}ol[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:1rem}a[_ngcontent-%COMP%]{text-decoration:underline;color:#000;transition:color .2s}a[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:focus{color:#333}a[_ngcontent-%COMP%]:hover{color:#333}sup[_ngcontent-%COMP%]{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-size:max(41%,.4em)}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.35rem}h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.275rem}h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.2rem}h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.15rem}h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.1rem}table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]{border-top:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]{border-bottom:none}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table[_ngcontent-%COMP%]   th[scope=row][_ngcontent-%COMP%]{text-align:left}html[_ngcontent-%COMP%]{box-sizing:border-box}*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:inherit}body[_ngcontent-%COMP%]{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body[_ngcontent-%COMP%]{font:-apple-system-body,sans-serif}}[_nghost-%COMP%]{display:flex;align-items:center;height:100%;letter-spacing:.04rem}.container[_ngcontent-%COMP%]{height:100%;z-index:1000}.container--active[_ngcontent-%COMP%], .container[_ngcontent-%COMP%]:hover, .container[_ngcontent-%COMP%]:focus, .container[_ngcontent-%COMP%]:active{box-shadow:0 -.2rem #fff inset}.area-button[_ngcontent-%COMP%]{height:100%;display:flex;align-items:center;justify-content:center;cursor:pointer}.text[_ngcontent-%COMP%]{display:flex;align-items:center;height:100%;padding:0 .8rem;background-color:inherit;text-decoration:inherit;color:inherit;font-size:1rem;letter-spacing:.04rem;text-transform:uppercase}.text[_ngcontent-%COMP%]:hover, .text[_ngcontent-%COMP%]:active, .text[_ngcontent-%COMP%]:focus, .text[_ngcontent-%COMP%]:focus-visible, .text[_ngcontent-%COMP%]:focus-within{color:inherit}.menu[_ngcontent-%COMP%]{display:none;justify-content:center;position:absolute;left:0;width:100%;border-top:1px solid #d9d9d9;color:#000;background:#fff;margin:0;padding:0 0 2rem;border-bottom:solid .8px #d9d9d9}.menu--active[_ngcontent-%COMP%]{display:flex}.column[_ngcontent-%COMP%]{display:block;margin:0;padding:0 3rem}.category-heading[_ngcontent-%COMP%]{display:block;padding:2rem 0 .875rem;cursor:auto;margin-bottom:1rem;min-height:1.25rem;border-bottom:1px solid #d9d9d9;letter-spacing:.04rem;text-transform:uppercase}.category-heading[_ngcontent-%COMP%]:focus{text-decoration:underline}.link[_ngcontent-%COMP%]{display:block;color:#000;padding:.5rem 0;font-size:.8125rem;line-height:1.25;text-decoration:none}.link[_ngcontent-%COMP%]:hover, .link[_ngcontent-%COMP%]:focus, .link[_ngcontent-%COMP%]:active{text-decoration:underline}\n\n"]
      });
    }
  }
  return HeaderNavAreaComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderNavComponent = /*#__PURE__*/(() => {
  class HeaderNavComponent {
    constructor(headerConfigurationService) {
      this.headerConfigurationService = headerConfigurationService;
    }
    static {
      this.ɵfac = function HeaderNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderNavComponent)(i0.ɵɵdirectiveInject(HeaderConfigurationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNavComponent,
        selectors: [["fly-header-nav"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[3, "area", 4, "ngFor", "ngForOf"], [3, "area"]],
        template: function HeaderNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HeaderNavComponent_fly_header_nav_area_0_Template, 1, 1, "fly-header-nav-area", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.headerConfigurationService.areas());
          }
        },
        dependencies: [i2.NgForOf, HeaderNavAreaComponent],
        styles: ["[_nghost-%COMP%]{display:flex;align-items:center;justify-content:center;height:4rem}@media screen and (max-width: 1200px){[_nghost-%COMP%]{height:2.5rem}}"]
      });
    }
  }
  return HeaderNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderSkipNavigationComponent = /*#__PURE__*/(() => {
  class HeaderSkipNavigationComponent {
    constructor() {
      this.skip = new EventEmitter();
    }
    ngAfterViewInit() {
      this.skipButton?.nativeElement.addEventListener('click', () => {
        this.skip.emit();
      });
    }
    static {
      this.ɵfac = function HeaderSkipNavigationComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderSkipNavigationComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderSkipNavigationComponent,
        selectors: [["fly-header-skip-navigation"]],
        viewQuery: function HeaderSkipNavigationComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c6, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.skipButton = _t.first);
          }
        },
        outputs: {
          skip: "skip"
        },
        standalone: false,
        decls: 3,
        vars: 0,
        consts: [["skipButton", ""]],
        template: function HeaderSkipNavigationComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", null, 0);
            i0.ɵɵtext(2, " Skip navigation links\n");
            i0.ɵɵelementEnd();
          }
        },
        styles: ["[_nghost-%COMP%]{position:absolute;top:0;left:0}button[_ngcontent-%COMP%]{background:#fff;color:#000;text-decoration:none;font-size:.8rem;padding:.25rem .5rem;transition:top .25s ease;position:relative;left:2rem;top:-25rem}button[_ngcontent-%COMP%]:focus{top:0}"]
      });
    }
  }
  return HeaderSkipNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let HeaderCartService = /*#__PURE__*/(() => {
  class HeaderCartService {
    constructor() {
      this.http = inject(HttpClient);
      this.config = inject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN);
      this.document = inject(DOCUMENT);
      this.cartItemQuantity = signal(null);
      this.refreshCart();
      // This custom DOM event comes from webapp since it cannot directly call the refreshCart method
      fromEvent(this.document, 'cartmodified').pipe(takeUntilDestroyed()).subscribe(() => {
        this.refreshCart();
      });
    }
    refreshCart() {
      this.getNumberOfCartItems().subscribe(cartItemQuantity => this.cartItemQuantity.set(cartItemQuantity));
    }
    getNumberOfCartItems() {
      return this.http.get(`${this.config.flyLegacyUrl}api/carts/current`).pipe(map(cart => [...cart.avdbBundleCart, ...cart.avdbCart, ...cart.enablementCart, ...cart.gpCart].length), catchError(() => of(null)));
    }
    static {
      this.ɵfac = function HeaderCartService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderCartService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: HeaderCartService,
        factory: HeaderCartService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return HeaderCartService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var SsoBaseUrl = /*#__PURE__*/function (SsoBaseUrl) {
  SsoBaseUrl["Dev"] = "https://ssodev.garmin.com";
  SsoBaseUrl["Test"] = "https://ssotest.garmin.com";
  SsoBaseUrl["Stage"] = "https://ssostg.garmin.com";
  SsoBaseUrl["Prod"] = "https://sso.garmin.com";
  return SsoBaseUrl;
}(SsoBaseUrl || {});
/**
 * This service is stolen functionality from:
 *   @garmin-avcloud/avcloud-web-util :: AuthService
 *
 * This is forked in order to allow a different client ID (FLY_GARMIN)
 * to be used for the SSO portal instead of the normal API client ID
 * (FLY_GARMIN_APP).
 */
let SsoPortalService = /*#__PURE__*/(() => {
  class SsoPortalService {
    constructor(sanitizer, document, config) {
      this.sanitizer = sanitizer;
      this.document = document;
      this.config = config;
      switch (this.config.environment) {
        case 'PROD':
          this.ssoBaseUrl = SsoBaseUrl.Prod;
          break;
        case 'STAGE':
          this.ssoBaseUrl = SsoBaseUrl.Stage;
          break;
        case 'TEST':
          this.ssoBaseUrl = SsoBaseUrl.Test;
          break;
        default:
          this.ssoBaseUrl = SsoBaseUrl.Dev;
          break;
      }
      /*
        LOCALE SHOULD NOT BE ENCODED INTO THE URL, IT SHOULD BE DETERMINED AUTOMATICALLY BY THE PORTAL PAGE.
        THE CURRENT PORTAL PAGE DOES NOT HANDLE THIS PROPERLY, SO THIS SHOULD BE UPDATED ONCE IT DOES.
      */
      this.portalUrl = `${this.ssoBaseUrl}/portal/sso/en-US/sign-in?` + `clientId=${encodeURIComponent(config.ssoClientId)}` + `&service=${encodeURIComponent(this.getCurrentUrlWithoutTicket().href)}`;
    }
    /**
     * Send the user to the SSO Login Portal
     */
    redirectToSsoLoginPortal() {
      this.redirectToUrl(this.portalUrl);
    }
    getCurrentUrlWithoutTicket() {
      const currentUrl = new URL(this.document.URL);
      currentUrl.searchParams.delete('ticket');
      return currentUrl;
    }
    redirectToUrl(url) {
      const sanitizedUrl = this.sanitizer.sanitize(SecurityContext.URL, url);
      if (sanitizedUrl != null) {
        this.document.location.href = sanitizedUrl;
      }
    }
    static {
      this.ɵfac = function SsoPortalService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SsoPortalService)(i0.ɵɵinject(i1.DomSanitizer), i0.ɵɵinject(DOCUMENT), i0.ɵɵinject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SsoPortalService,
        factory: SsoPortalService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SsoPortalService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NavigationBarDropdownService = /*#__PURE__*/(() => {
  class NavigationBarDropdownService {
    constructor() {
      this.isNavIconOpen = signal(false);
      this.isNavMenuOpen = signal(false);
    }
    static {
      this.ɵfac = function NavigationBarDropdownService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NavigationBarDropdownService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NavigationBarDropdownService,
        factory: NavigationBarDropdownService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NavigationBarDropdownService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This is a component that displays an interactive button with a menu of links. Hovering
 * over the button, clicking the button, or pressing Enter when focused on the button will
 * open the menu. Moving the mouse away or moving focus outside the menu will close the menu.
 *
 * The button and menu links are provided through content projection within the nav-menu-content div.
 *
 * Example:
 * ```
 *   <fly-header-nav-menu>
 *     <img src="assets/icon/account.svg">
 *     <div class="nav-menu-content">
 *       <a href="https://www.garmin.com/account">Account</a>
 *     </div>
 *   </fly-header-nav-menu>
 * ```
 */
let HeaderNavMenuComponent = /*#__PURE__*/(() => {
  class HeaderNavMenuComponent {
    constructor() {
      this.isOpen = false;
      this.onOpen = new Subject();
      this.navigationBarDropdownService = inject(NavigationBarDropdownService);
      this.destroyRef = inject(DestroyRef);
      this.injector = inject(Injector);
    }
    ngOnInit() {
      effect(() => {
        if (this.navigationBarDropdownService.isNavIconOpen()) {
          this.isOpen = false;
          this.close();
        }
      }, {
        injector: this.injector
      });
    }
    ngAfterViewInit() {
      this.container.nativeElement.addEventListener('mouseenter', () => this.onMouseEnter());
      this.container.nativeElement.addEventListener('mouseleave', () => this.onMouseLeave());
      this.container.nativeElement.addEventListener('focusout', event => this.onFocusOut(event));
      this.button.nativeElement.addEventListener('keypress', event => this.onKeyPress(event));
      this.button.nativeElement.addEventListener('click', () => this.onClick());
    }
    close() {
      this.container.nativeElement.classList.add('nav-menu-container-closed');
      this.menu.nativeElement.classList.add('nav-menu-closed');
    }
    open() {
      this.container.nativeElement.classList.remove('nav-menu-container-closed');
      this.menu.nativeElement.classList.remove('nav-menu-closed');
      this.onOpen.next(null);
    }
    onClick() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.open();
        this.menu.nativeElement.querySelector('a')?.focus();
        this.navigationBarDropdownService.isNavIconOpen.set(false);
        this.navigationBarDropdownService.isNavMenuOpen.set(true);
      } else {
        this.close();
        this.menu.nativeElement.querySelector('a')?.blur();
        this.navigationBarDropdownService.isNavMenuOpen.set(false);
      }
    }
    onFocusOut(event) {
      const newFocus = event.relatedTarget;
      if (newFocus != null && !newFocus.classList.contains('nav-menu-content')) {
        this.close();
      }
    }
    onKeyPress(event) {
      if (event.key === 'Enter') {
        this.open();
        this.menu.nativeElement.querySelector('a')?.focus();
      }
    }
    onMouseEnter() {
      this.open();
    }
    onMouseLeave() {
      //don't immediately hide, don't hide if user is back in the nav
      timer(250).pipe(takeUntil(this.onOpen), takeUntilDestroyed(this.destroyRef)).subscribe(() => this.close());
    }
    static {
      this.ɵfac = function HeaderNavMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderNavMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderNavMenuComponent,
        selectors: [["fly-header-nav-menu"]],
        viewQuery: function HeaderNavMenuComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.container = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.button = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menu = _t.first);
          }
        },
        standalone: false,
        ngContentSelectors: _c8,
        decls: 8,
        vars: 0,
        consts: [["container", ""], ["button", ""], ["menu", ""], [1, "nav-menu-container", "nav-menu-container-closed"], ["tabindex", "0", 1, "nav-menu-button"], [1, "nav-menu", "nav-menu-closed"]],
        template: function HeaderNavMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c7);
            i0.ɵɵelementStart(0, "div", 3, 0)(2, "li", 4, 1);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5, 2);
            i0.ɵɵprojection(7, 1);
            i0.ɵɵelementEnd()();
          }
        },
        styles: [".nav-menu-container[_ngcontent-%COMP%]{display:flex;align-items:center;font-size:.825rem;margin-left:.5rem;min-height:4rem;z-index:1000;box-shadow:0 -.2rem #fff inset}.nav-menu-container-closed[_ngcontent-%COMP%]{box-shadow:revert}@media screen and (max-width: 1200px){.nav-menu-container[_ngcontent-%COMP%]{min-height:4.5rem}}@media screen and (max-width: 1024px){.nav-menu-container[_ngcontent-%COMP%]{min-height:3.125rem}}.nav-menu-button[_ngcontent-%COMP%]{display:flex}.nav-menu[_ngcontent-%COMP%]{color:#000;padding:0 1rem;min-width:16rem;position:absolute;top:4rem;right:1.5rem;background:#fff;border:#eee 1px solid;box-sizing:border-box;z-index:1001}.nav-menu-closed[_ngcontent-%COMP%]{display:none}@media screen and (max-width: 1200px){.nav-menu[_ngcontent-%COMP%]{top:4.5rem}}@media screen and (max-width: 1024px){.nav-menu[_ngcontent-%COMP%]{top:3.125rem;right:0;width:100%}}"]
      });
    }
  }
  return HeaderNavMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var AccountUrl = /*#__PURE__*/function (AccountUrl) {
  AccountUrl["Dev"] = "https://www.dev.garmin.com/en-US/account";
  AccountUrl["Test"] = "https://www.dev.garmin.com/en-US/account";
  AccountUrl["Stage"] = "https://www.dev.garmin.com/en-US/account";
  AccountUrl["Prod"] = "https://www.garmin.com/en-US/account";
  return AccountUrl;
}(AccountUrl || {});
const LOGOUT_PATH = 'logout';
const CART_PATH = 'purchasing/cart';
const SUPPORT_PATH = 'aviation-support';
const SELECT_PROFILE_PATH = 'select-profile';
let HeaderUtilityBarComponent = /*#__PURE__*/(() => {
  class HeaderUtilityBarComponent {
    constructor(headerCartService, router, ssoPortalService, document, config) {
      this.headerCartService = headerCartService;
      this.router = router;
      this.ssoPortalService = ssoPortalService;
      this.document = document;
      this.config = config;
      this.customer = null;
      this.membershipCount = 0;
      this.canUseRouterLink = false;
      this.customerFirstName = '';
      this.headerConfigurationService = inject(HeaderConfigurationService);
      switch (this.config.environment) {
        case 'DEV':
          this.accountUrl = AccountUrl.Dev;
          break;
        case 'TEST':
          this.accountUrl = AccountUrl.Test;
          break;
        case 'STAGE':
          this.accountUrl = AccountUrl.Stage;
          break;
        case 'PROD':
        default:
          this.accountUrl = AccountUrl.Prod;
          break;
      }
      this.logoutUrl = this.config.fgUrl + LOGOUT_PATH;
      this.cartUrl = this.config.fgUrl + CART_PATH;
      this.supportUrl = this.config.fgUrl + SUPPORT_PATH;
      this.selectProfileUrl = this.config.fgUrl + SELECT_PROFILE_PATH;
    }
    ngOnInit() {
      if (this.config.ssoClientId === 'FLY_GARMIN_APP') {
        this.canUseRouterLink = true;
      }
      this.customerFirstName = this.customer?.name.split(' ')[0] ?? '';
    }
    onClickAccountButton() {
      this.document.location.assign(this.accountUrl);
    }
    onClickSignInButton() {
      this.ssoPortalService.redirectToSsoLoginPortal();
    }
    onClickSignOutButton() {
      if (this.canUseRouterLink) {
        this.router.navigate([LOGOUT_PATH]);
      } else {
        this.document.location.assign(this.logoutUrl);
      }
    }
    onClickChangeProfileButton() {
      this.document.location.assign(this.selectProfileUrl);
    }
    static {
      this.ɵfac = function HeaderUtilityBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderUtilityBarComponent)(i0.ɵɵdirectiveInject(HeaderCartService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(SsoPortalService), i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderUtilityBarComponent,
        selectors: [["fly-header-utility-bar"]],
        viewQuery: function HeaderUtilityBarComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c9, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.skipLinks = _t);
          }
        },
        inputs: {
          customer: "customer",
          membershipCount: "membershipCount"
        },
        standalone: false,
        decls: 19,
        vars: 9,
        consts: [["skipLink", ""], ["hrefSupportLink", ""], ["hrefCartLink", ""], ["orgDisplay", ""], [1, "container"], [1, "utility-bar-item", "utility-bar-item-closed", "support-item"], ["class", "support-link", "target", "_blank", "routerLink", "aviation-support", 4, "ngIf", "ngIfElse"], ["alt", "Account", "src", "https://static.garmincdn.com/apps/fly/img/icons/account.svg", 1, "account-icon"], [1, "nav-menu-content"], ["class", "customer-info", 4, "ngIf"], ["class", "profile-info", 4, "ngIf"], [1, "buttons"], ["target", "_blank", 3, "click", 4, "ngIf"], [3, "click", 4, "ngIf"], [1, "utility-bar-item", "utility-bar-item-closed"], ["class", "cart-link", "routerLink", "purchasing/cart", 4, "ngIf", "ngIfElse"], ["target", "_blank", "routerLink", "aviation-support", 1, "support-link"], ["alt", "Support", "aria-hidden", "true", "src", "https://static.garmincdn.com/apps/fly/img/icons/support.svg", 1, "support-icon"], [1, "link"], [1, "customer-info"], [1, "description"], [1, "profile-info"], [1, "profile"], [4, "ngIf", "ngIfElse"], [3, "click"], ["target", "_blank", 3, "click"], ["routerLink", "purchasing/cart", 1, "cart-link"], [1, "cart-icon-quantity"], ["alt", "Cart", "src", "https://static.garmincdn.com/apps/fly/img/icons/cart.svg", 1, "cart-icon"], ["target", "_blank", 1, "support-link", 3, "href"], [1, "cart-link", 3, "href"]],
        template: function HeaderUtilityBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 4)(1, "div", 5);
            i0.ɵɵtemplate(2, HeaderUtilityBarComponent_a_2_Template, 5, 0, "a", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "fly-header-nav-menu", null, 0);
            i0.ɵɵelement(5, "img", 7);
            i0.ɵɵelementStart(6, "div", 8);
            i0.ɵɵtemplate(7, HeaderUtilityBarComponent_section_7_Template, 5, 2, "section", 9)(8, HeaderUtilityBarComponent_section_8_Template, 9, 2, "section", 10);
            i0.ɵɵelementStart(9, "section", 11);
            i0.ɵɵtemplate(10, HeaderUtilityBarComponent_button_10_Template, 2, 0, "button", 12)(11, HeaderUtilityBarComponent_button_11_Template, 2, 0, "button", 13)(12, HeaderUtilityBarComponent_button_12_Template, 2, 0, "button", 13);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelementStart(13, "div", 14);
            i0.ɵɵtemplate(14, HeaderUtilityBarComponent_a_14_Template, 4, 1, "a", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, HeaderUtilityBarComponent_ng_template_15_Template, 5, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(17, HeaderUtilityBarComponent_ng_template_17_Template, 4, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const hrefSupportLink_r7 = i0.ɵɵreference(16);
            const hrefCartLink_r8 = i0.ɵɵreference(18);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.canUseRouterLink)("ngIfElse", hrefSupportLink_r7);
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngIf", ctx.customer != null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.customer != null && ctx.membershipCount > 0 && ctx.headerConfigurationService.orgsEnabled());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.customer != null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.customer != null);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.customer == null);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.canUseRouterLink)("ngIfElse", hrefCartLink_r8);
          }
        },
        dependencies: [i2.NgIf, i2$1.RouterLink, HeaderNavMenuComponent],
        styles: [".container[_ngcontent-%COMP%]{display:flex}@media screen and (max-width: 1200px){.container[_ngcontent-%COMP%]{margin-right:1.5rem}}.link[_ngcontent-%COMP%]{color:#fff;text-decoration:none}.utility-bar-item[_ngcontent-%COMP%]{display:flex;align-items:center;font-size:.825rem;margin-left:.5rem;min-height:4rem;cursor:pointer;box-shadow:0 -.2rem #fff inset}.utility-bar-item-closed[_ngcontent-%COMP%]{box-shadow:unset}.utility-bar-item[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]{display:flex}@media screen and (max-width: 1024px){.utility-bar-item[_ngcontent-%COMP%]{min-height:3rem}}.support-item[_ngcontent-%COMP%]{margin-right:1rem}@media screen and (max-width: 1024px){.support-item[_ngcontent-%COMP%]{display:none}}.support-link[_ngcontent-%COMP%]{display:flex;align-items:center;padding:.25rem 0}.support-link[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{margin-left:.4rem}.support-icon[_ngcontent-%COMP%]{width:1.125rem;max-height:1.125rem}.account-icon[_ngcontent-%COMP%]{display:flex;width:1.875rem;max-height:1.875rem;cursor:pointer}.cart-link[_ngcontent-%COMP%]{position:relative}.cart-icon[_ngcontent-%COMP%]{width:1.875rem;max-height:1.875rem}.cart-icon-quantity[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;position:absolute;top:-.125rem;right:-.25rem;width:1.25rem;height:1.25rem;color:#000;background:#fff;border-radius:100%;font-family:Roboto;font-weight:500}.hidden[_ngcontent-%COMP%]{display:none}.nav-menu-item[_ngcontent-%COMP%]{margin-bottom:1rem}button[_ngcontent-%COMP%]{display:block}button[_ngcontent-%COMP%]:hover{text-decoration:underline;cursor:pointer}section[_ngcontent-%COMP%]{padding:1rem 0}section[_ngcontent-%COMP%]:not(:last-child){border-bottom:1px solid rgb(114.75,114.75,114.75)}.customer-info[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.75rem}.customer-info[_ngcontent-%COMP%] > header[_ngcontent-%COMP%]{font-size:1rem;font-weight:700}.profile-info[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.75rem}.profile-info[_ngcontent-%COMP%] > header[_ngcontent-%COMP%]{font-weight:300;letter-spacing:.05rem;color:#737373}.profile-info[_ngcontent-%COMP%] > .profile[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:baseline;gap:1rem}.profile-info[_ngcontent-%COMP%] > .profile[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-weight:700}.buttons[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:.75rem}"]
      });
    }
  }
  return HeaderUtilityBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileNavOpenComponent = /*#__PURE__*/(() => {
  class MobileNavOpenComponent {
    ngOnChanges(changes) {
      if (changes['open'] != null) {
        this.open = JSON.parse(changes['open'].currentValue);
      }
    }
    static {
      this.ɵfac = function MobileNavOpenComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileNavOpenComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileNavOpenComponent,
        selectors: [["fly-mobile-nav-open"]],
        inputs: {
          open: "open"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 7,
        vars: 4,
        consts: [["plus", ""], ["minus", ""], [1, "g-plus"], [3, "ngTemplateOutlet", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "width", "14px", "viewBox", "0 0 12 12", "version", "1.1", 1, "plus"], ["stroke", "none", "stroke-width", "1", "fill", "none", "fill-rule", "evenodd"], ["transform", "translate(-347.000000, -136.000000)", "fill", "#000000"], ["points", "352.142857 136 352.142857 141.142857 347 141.142857 347 142.857143 352.142857 142.857143 352.142857 148 353.857143 148 353.857143 142.857143 359 142.857143 359 141.142857 353.857143 141.142857 353.857143 136"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 455 31", "width", "15px", 1, "minus"], ["d", "M0 0.5L455 0.5L455 30.5L0 30.5L0 0.5Z", 1, "shp0"], [3, "ngTemplateOutlet"]],
        template: function MobileNavOpenComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MobileNavOpenComponent_ng_template_0_Template, 4, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, MobileNavOpenComponent_ng_template_2_Template, 4, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(4, "span", 2);
            i0.ɵɵtemplate(5, MobileNavOpenComponent_ng_container_5_Template, 1, 1, "ng-container", 3)(6, MobileNavOpenComponent_ng_container_6_Template, 1, 1, "ng-container", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵclassProp("open", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.open);
          }
        },
        dependencies: [i2.NgIf, i2.NgTemplateOutlet],
        styles: [".g-plus.open[_ngcontent-%COMP%]{display:flex}"]
      });
    }
  }
  return MobileNavOpenComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileNavSubcategoryComponent = /*#__PURE__*/(() => {
  class MobileNavSubcategoryComponent {
    constructor(headerConfigurationService, config) {
      this.headerConfigurationService = headerConfigurationService;
      this.open = false;
      this.hasBottomBorder = false;
      this.ssoClientId = '';
      this.ssoClientId = config.ssoClientId;
    }
    onDropdownSubClick() {
      this.open = !this.open;
    }
    static {
      this.ɵfac = function MobileNavSubcategoryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileNavSubcategoryComponent)(i0.ɵɵdirectiveInject(HeaderConfigurationService), i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileNavSubcategoryComponent,
        selectors: [["fly-mobile-nav-subcategory"]],
        inputs: {
          category: "category"
        },
        standalone: false,
        decls: 6,
        vars: 5,
        consts: [["useRouterLink", ""], ["useHrefLink", ""], ["tabindex", "0", 1, "category-heading", 3, "click", "keydown.enter"], [1, "c-name"], [3, "open"], ["class", "link-container", 4, "ngIf"], [1, "link-container"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "link", 3, "routerLink"], [1, "link", 3, "href"]],
        template: function MobileNavSubcategoryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵlistener("click", function MobileNavSubcategoryComponent_Template_div_click_0_listener() {
              return ctx.onDropdownSubClick();
            })("keydown.enter", function MobileNavSubcategoryComponent_Template_div_keydown_enter_0_listener() {
              return ctx.onDropdownSubClick();
            });
            i0.ɵɵelementStart(1, "span", 3);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "span");
            i0.ɵɵelement(4, "fly-mobile-nav-open", 4);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(5, MobileNavSubcategoryComponent_div_5_Template, 2, 1, "div", 5);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("bottom-border", ctx.hasBottomBorder);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.category.name);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("open", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.open);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2$1.RouterLink, MobileNavOpenComponent, HrefLinkPipe],
        styles: ["body[_ngcontent-%COMP%]{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body[_ngcontent-%COMP%]{font-weight:400}.category-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html[_ngcontent-%COMP%]{line-height:1.15;-webkit-text-size-adjust:100%}body[_ngcontent-%COMP%]{margin:0}main[_ngcontent-%COMP%]{display:block}h1[_ngcontent-%COMP%]{font-size:2em;margin:.67em 0}hr[_ngcontent-%COMP%]{box-sizing:content-box;height:0;overflow:visible}pre[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}a[_ngcontent-%COMP%]{background-color:transparent}abbr[title][_ngcontent-%COMP%]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b[_ngcontent-%COMP%], strong[_ngcontent-%COMP%]{font-weight:bolder}code[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], samp[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}small[_ngcontent-%COMP%]{font-size:80%}sub[_ngcontent-%COMP%], sup[_ngcontent-%COMP%]{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub[_ngcontent-%COMP%]{bottom:-.25em}sup[_ngcontent-%COMP%]{top:-.5em}img[_ngcontent-%COMP%]{border-style:none}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%], optgroup[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{overflow:visible}button[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{text-transform:none}button[_ngcontent-%COMP%], [type=button][_ngcontent-%COMP%], [type=reset][_ngcontent-%COMP%], [type=submit][_ngcontent-%COMP%]{-webkit-appearance:button}button[_ngcontent-%COMP%]::-moz-focus-inner, [type=button][_ngcontent-%COMP%]::-moz-focus-inner, [type=reset][_ngcontent-%COMP%]::-moz-focus-inner, [type=submit][_ngcontent-%COMP%]::-moz-focus-inner{border-style:none;padding:0}button[_ngcontent-%COMP%]:-moz-focusring, [type=button][_ngcontent-%COMP%]:-moz-focusring, [type=reset][_ngcontent-%COMP%]:-moz-focusring, [type=submit][_ngcontent-%COMP%]:-moz-focusring{outline:1px dotted ButtonText}fieldset[_ngcontent-%COMP%]{padding:.35em .75em .625em}legend[_ngcontent-%COMP%]{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress[_ngcontent-%COMP%]{vertical-align:baseline}textarea[_ngcontent-%COMP%]{overflow:auto}[type=checkbox][_ngcontent-%COMP%], [type=radio][_ngcontent-%COMP%]{box-sizing:border-box;padding:0}[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, [type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{height:auto}[type=search][_ngcontent-%COMP%]{-webkit-appearance:textfield;outline-offset:-2px}[type=search][_ngcontent-%COMP%]::-webkit-search-decoration{-webkit-appearance:none}[_ngcontent-%COMP%]::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details[_ngcontent-%COMP%]{display:block}summary[_ngcontent-%COMP%]{display:list-item}template[_ngcontent-%COMP%]{display:none}[hidden][_ngcontent-%COMP%]{display:none}code[_ngcontent-%COMP%]{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1[_ngcontent-%COMP%]{font-size:2.5rem}}h2[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2[_ngcontent-%COMP%]{font-size:2rem}}h3[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3[_ngcontent-%COMP%]{font-size:1.5rem}}h4[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4[_ngcontent-%COMP%]{font-size:1.25rem}}h5[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5[_ngcontent-%COMP%]{font-size:1rem}}h6[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6[_ngcontent-%COMP%]{font-size:1rem}}ol[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:1rem}a[_ngcontent-%COMP%]{text-decoration:underline;color:#000;transition:color .2s}a[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:focus{color:#333}a[_ngcontent-%COMP%]:hover{color:#333}sup[_ngcontent-%COMP%]{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-size:max(41%,.4em)}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.35rem}h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.275rem}h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.2rem}h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.15rem}h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.1rem}table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]{border-top:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]{border-bottom:none}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table[_ngcontent-%COMP%]   th[scope=row][_ngcontent-%COMP%]{text-align:left}html[_ngcontent-%COMP%]{box-sizing:border-box}*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:inherit}body[_ngcontent-%COMP%]{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body[_ngcontent-%COMP%]{font:-apple-system-body,sans-serif}}.category-heading[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;padding:1rem 0 1rem 1rem;border-bottom:1px solid #d9d9d9;text-transform:uppercase;line-height:2rem;cursor:auto}.category-heading[_ngcontent-%COMP%]:hover{cursor:pointer}.category-heading[_ngcontent-%COMP%]:focus{text-decoration:underline}.link-container[_ngcontent-%COMP%]{text-align:left}.link[_ngcontent-%COMP%]{display:block;padding:.875rem 2rem;font-size:.8125rem;letter-spacing:.04rem;line-height:1.25;text-decoration:none}.link[_ngcontent-%COMP%]:hover, .link[_ngcontent-%COMP%]:focus, .link[_ngcontent-%COMP%]:active{text-decoration:underline}\n\n"]
      });
    }
  }
  return MobileNavSubcategoryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileNavCategoryComponent = /*#__PURE__*/(() => {
  class MobileNavCategoryComponent {
    constructor(headerConfigurationService, config) {
      this.headerConfigurationService = headerConfigurationService;
      this.config = config;
      this.open = false;
      this.ssoClientId = '';
      this.ssoClientId = config.ssoClientId;
    }
    onDropdownHeaderClick() {
      this.open = !this.open;
    }
    static {
      this.ɵfac = function MobileNavCategoryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileNavCategoryComponent)(i0.ɵɵdirectiveInject(HeaderConfigurationService), i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileNavCategoryComponent,
        selectors: [["fly-mobile-nav-category"]],
        inputs: {
          area: "area",
          enableTopBorder: "enableTopBorder"
        },
        standalone: false,
        decls: 7,
        vars: 7,
        consts: [["useRouterLink", ""], ["useHrefLink", ""], [1, "category-wrapper"], ["tabindex", "0", 1, "category-heading", 3, "click", "keydown.enter"], [1, "name"], [3, "open"], ["class", "e", 4, "ngIf"], [1, "e"], ["class", "column", 4, "ngFor", "ngForOf"], [1, "column"], [4, "ngIf"], [3, "category"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "link", 3, "routerLink"], [1, "link", 3, "href"]],
        template: function MobileNavCategoryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
            i0.ɵɵlistener("click", function MobileNavCategoryComponent_Template_div_click_1_listener() {
              return ctx.onDropdownHeaderClick();
            })("keydown.enter", function MobileNavCategoryComponent_Template_div_keydown_enter_1_listener() {
              return ctx.onDropdownHeaderClick();
            });
            i0.ɵɵelementStart(2, "span", 4);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "span");
            i0.ɵɵelement(5, "fly-mobile-nav-open", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(6, MobileNavCategoryComponent_ng_container_6_Template, 2, 1, "ng-container", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("bordered", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("bordered", ctx.enableTopBorder === true && ctx.open);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.area.name);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("open", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.open === true);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2$1.RouterLink, MobileNavOpenComponent, MobileNavSubcategoryComponent, HrefLinkPipe],
        styles: ["body[_ngcontent-%COMP%]{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body[_ngcontent-%COMP%]{font-weight:400}.category-heading[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html[_ngcontent-%COMP%]{line-height:1.15;-webkit-text-size-adjust:100%}body[_ngcontent-%COMP%]{margin:0}main[_ngcontent-%COMP%]{display:block}h1[_ngcontent-%COMP%]{font-size:2em;margin:.67em 0}hr[_ngcontent-%COMP%]{box-sizing:content-box;height:0;overflow:visible}pre[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}a[_ngcontent-%COMP%]{background-color:transparent}abbr[title][_ngcontent-%COMP%]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b[_ngcontent-%COMP%], strong[_ngcontent-%COMP%]{font-weight:bolder}code[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], samp[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}small[_ngcontent-%COMP%]{font-size:80%}sub[_ngcontent-%COMP%], sup[_ngcontent-%COMP%]{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub[_ngcontent-%COMP%]{bottom:-.25em}sup[_ngcontent-%COMP%]{top:-.5em}img[_ngcontent-%COMP%]{border-style:none}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%], optgroup[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{overflow:visible}button[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{text-transform:none}button[_ngcontent-%COMP%], [type=button][_ngcontent-%COMP%], [type=reset][_ngcontent-%COMP%], [type=submit][_ngcontent-%COMP%]{-webkit-appearance:button}button[_ngcontent-%COMP%]::-moz-focus-inner, [type=button][_ngcontent-%COMP%]::-moz-focus-inner, [type=reset][_ngcontent-%COMP%]::-moz-focus-inner, [type=submit][_ngcontent-%COMP%]::-moz-focus-inner{border-style:none;padding:0}button[_ngcontent-%COMP%]:-moz-focusring, [type=button][_ngcontent-%COMP%]:-moz-focusring, [type=reset][_ngcontent-%COMP%]:-moz-focusring, [type=submit][_ngcontent-%COMP%]:-moz-focusring{outline:1px dotted ButtonText}fieldset[_ngcontent-%COMP%]{padding:.35em .75em .625em}legend[_ngcontent-%COMP%]{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress[_ngcontent-%COMP%]{vertical-align:baseline}textarea[_ngcontent-%COMP%]{overflow:auto}[type=checkbox][_ngcontent-%COMP%], [type=radio][_ngcontent-%COMP%]{box-sizing:border-box;padding:0}[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, [type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{height:auto}[type=search][_ngcontent-%COMP%]{-webkit-appearance:textfield;outline-offset:-2px}[type=search][_ngcontent-%COMP%]::-webkit-search-decoration{-webkit-appearance:none}[_ngcontent-%COMP%]::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details[_ngcontent-%COMP%]{display:block}summary[_ngcontent-%COMP%]{display:list-item}template[_ngcontent-%COMP%]{display:none}[hidden][_ngcontent-%COMP%]{display:none}code[_ngcontent-%COMP%]{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1[_ngcontent-%COMP%]{font-size:2.5rem}}h2[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2[_ngcontent-%COMP%]{font-size:2rem}}h3[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3[_ngcontent-%COMP%]{font-size:1.5rem}}h4[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4[_ngcontent-%COMP%]{font-size:1.25rem}}h5[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5[_ngcontent-%COMP%]{font-size:1rem}}h6[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6[_ngcontent-%COMP%]{font-size:1rem}}ol[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:1rem}a[_ngcontent-%COMP%]{text-decoration:underline;color:#000;transition:color .2s}a[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:focus{color:#333}a[_ngcontent-%COMP%]:hover{color:#333}sup[_ngcontent-%COMP%]{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-size:max(41%,.4em)}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.35rem}h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.275rem}h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.2rem}h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.15rem}h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.1rem}table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]{border-top:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]{border-bottom:none}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table[_ngcontent-%COMP%]   th[scope=row][_ngcontent-%COMP%]{text-align:left}html[_ngcontent-%COMP%]{box-sizing:border-box}*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:inherit}body[_ngcontent-%COMP%]{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body[_ngcontent-%COMP%]{font:-apple-system-body,sans-serif}}.category-wrapper[_ngcontent-%COMP%]{margin:0 1rem}.category-wrapper.bordered[_ngcontent-%COMP%]{border-bottom:1px solid #000}.category-heading[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;padding:1rem 0;border-bottom:1px solid #d9d9d9;text-transform:uppercase;line-height:2rem;cursor:auto}.category-heading.bordered[_ngcontent-%COMP%]{border-top:1px solid #000}.category-heading[_ngcontent-%COMP%]:hover{cursor:pointer}.category-heading[_ngcontent-%COMP%]:focus{text-decoration:underline}.category-heading[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{display:flex;align-items:center}.link-container[_ngcontent-%COMP%]{text-align:left}.link[_ngcontent-%COMP%]{display:block;padding:.875rem 2rem;font-size:.8125rem;letter-spacing:.04rem;line-height:1.25;text-decoration:none}.link[_ngcontent-%COMP%]:hover, .link[_ngcontent-%COMP%]:focus, .link[_ngcontent-%COMP%]:active{text-decoration:underline}\n\n"]
      });
    }
  }
  return MobileNavCategoryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileNavComponent = /*#__PURE__*/(() => {
  class MobileNavComponent {
    constructor(headerConfigurationService) {
      this.headerConfigurationService = headerConfigurationService;
    }
    static {
      this.ɵfac = function MobileNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileNavComponent)(i0.ɵɵdirectiveInject(HeaderConfigurationService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileNavComponent,
        selectors: [["fly-mobile-nav"]],
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[4, "ngFor", "ngForOf"], [3, "area", "enableTopBorder"]],
        template: function MobileNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MobileNavComponent_div_0_Template, 2, 2, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngForOf", ctx.headerConfigurationService.areas());
          }
        },
        dependencies: [i2.NgForOf, MobileNavCategoryComponent],
        encapsulation: 2
      });
    }
  }
  return MobileNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileNavIconComponent = /*#__PURE__*/(() => {
  class MobileNavIconComponent {
    constructor() {
      this.isOpen = false;
      this.navigationBarDropdownService = inject(NavigationBarDropdownService);
      effect(() => {
        if (this.navigationBarDropdownService.isNavMenuOpen()) {
          this.isOpen = false;
        }
      });
    }
    ngAfterViewInit() {
      this.hamburger.nativeElement.addEventListener('click', () => this.onClick());
      this.hamburger.nativeElement.addEventListener('keypress', event => this.onKeyPress(event));
    }
    onKeyPress(event) {
      if (event.key === 'Enter') {
        this.onClick();
      }
    }
    onClick() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.navigationBarDropdownService.isNavMenuOpen.set(false);
        this.navigationBarDropdownService.isNavIconOpen.set(true);
      } else {
        this.navigationBarDropdownService.isNavIconOpen.set(false);
      }
    }
    static {
      this.ɵfac = function MobileNavIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileNavIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileNavIconComponent,
        selectors: [["fly-mobile-nav-icon"]],
        viewQuery: function MobileNavIconComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c10, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hamburger = _t.first);
          }
        },
        standalone: false,
        decls: 6,
        vars: 5,
        consts: [["hamburgerMenu", ""], [1, "container"], ["tabindex", "0", 1, "g-hamburger"], ["id", "g-ham-top", 1, "g-hamburger-top"], [1, "g-hamburger-bottom"], ["class", "menu", 4, "ngIf"], [1, "menu"]],
        template: function MobileNavIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1)(1, "div", 2, 0);
            i0.ɵɵelement(3, "div", 3)(4, "div", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, MobileNavIconComponent_div_5_Template, 2, 0, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("open", ctx.isOpen === true);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("open", ctx.isOpen === true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isOpen === true);
          }
        },
        dependencies: [i2.NgIf, MobileNavComponent],
        styles: [".g-hamburger[_ngcontent-%COMP%]{position:absolute;left:0;width:20px;height:11px;padding:1.25rem;top:0}.g-hamburger[_ngcontent-%COMP%]:hover{cursor:pointer}.g-hamburger-bottom[_ngcontent-%COMP%], .g-hamburger-top[_ngcontent-%COMP%]{position:absolute;background:#fff;height:2px;width:20px;border-radius:20px;transform:rotate(0);transition:all ease .5s;transform-origin:center center}.g-hamburger-bottom[_ngcontent-%COMP%]{transform:translateY(8px)}.g-hamburger-top.open[_ngcontent-%COMP%]{transform:translateY(4px) rotate(-45deg)}.g-hamburger-bottom.open[_ngcontent-%COMP%]{transform:translateY(4px) rotate(45deg)}.g-plus[_ngcontent-%COMP%]{position:absolute;transform:rotate(0);transform-origin:center center;left:95%;padding-right:1.25rem}.g-plus.open[_ngcontent-%COMP%]{transform:translateY(-4px)}.menu[_ngcontent-%COMP%]{display:block;justify-content:center;position:absolute;left:0;width:100%;height:100%;min-height:3320px;color:#000;background:#fff;margin:0;top:3rem;z-index:10000;overflow:hidden}.menu[_ngcontent-%COMP%]:first-child{margin-top:1rem}"]
      });
    }
  }
  return MobileNavIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Turns a crazy boolean into a sane boolean.
 *
 * @note
 * This is a regular "function" versus an arrow function so we can use
 * it as the `transform` property of `@Input`.
 *
 * @note
 * This is different from `booleanAttribute` which considers any string other
 * than "false" to be true (even ""). `bool` flips that around and considers
 * any string other than "true" to be false (even "").
 */
function bool(val) {
  return val != null && String(val) === 'true';
}
function customer(val) {
  return typeof val === "string" ? JSON.parse(val) : val;
}
let HeaderComponent = /*#__PURE__*/(() => {
  class HeaderComponent {
    constructor() {
      this.enableLogoLink = true;
      this.enableNav = true;
      this.logoLink = '/';
      this.oem = false;
      this.dealer = false;
      this.orgName = null;
      this.membershipCount = 0;
      this.customer = null;
      this.headerConfigurationService = inject(HeaderConfigurationService);
    }
    ngOnChanges() {
      this.headerConfigurationService.init(this.dealer, this.oem, this.customer != null, this.orgName);
    }
    skipNavigation() {
      for (const element of this.utilityBar.skipLinks) {
        if (element.nativeElement != null && element.nativeElement.offsetParent != null) {
          element.nativeElement.focus();
          break;
        }
        if (element.button != null && element.button.nativeElement.offsetParent != null) {
          element.button.nativeElement.focus();
          break;
        }
      }
    }
    static {
      this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderComponent,
        selectors: [["fly-header"]],
        viewQuery: function HeaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.utilityBar = _t.first);
          }
        },
        inputs: {
          enableLogoLink: "enableLogoLink",
          enableNav: "enableNav",
          logoLink: "logoLink",
          oem: [2, "oem", "oem", bool],
          dealer: [2, "dealer", "dealer", bool],
          orgName: "orgName",
          membershipCount: "membershipCount",
          customer: [2, "customer", "customer", customer]
        },
        standalone: false,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature],
        decls: 12,
        vars: 4,
        consts: [["utilityBar", ""], [1, "header"], [3, "skip"], [1, "logo"], [3, "enableLink", "link"], [1, "nav"], [1, "top-content"], [1, "mobile-nav"], [1, "utility-bar"], [3, "customer", "membershipCount"]],
        template: function HeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1)(1, "fly-header-skip-navigation", 2);
            i0.ɵɵlistener("skip", function HeaderComponent_Template_fly_header_skip_navigation_skip_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.skipNavigation());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵelement(3, "fly-header-logo", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 5);
            i0.ɵɵelement(5, "fly-header-nav");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
            i0.ɵɵelement(8, "fly-mobile-nav-icon");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 8);
            i0.ɵɵelement(10, "fly-header-utility-bar", 9, 0);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("enableLink", ctx.enableLogoLink)("link", ctx.logoLink);
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("customer", ctx.customer)("membershipCount", ctx.membershipCount);
          }
        },
        dependencies: [HeaderLogoComponent, HeaderNavComponent, HeaderSkipNavigationComponent, HeaderUtilityBarComponent, MobileNavIconComponent],
        styles: ["*:where(:not(html,iframe,canvas,img,svg,video,audio):not(svg *,symbol *)){all:unset;display:revert}*,*:before,*:after{box-sizing:border-box}a,button{cursor:revert}ol,ul,menu{list-style:none}img{max-width:100%}table{border-collapse:collapse}input,textarea{-webkit-user-select:auto}textarea{white-space:revert}meter{-webkit-appearance:revert;appearance:revert}::placeholder{color:unset}:where([hidden]){display:none}:where([contenteditable]:not([contenteditable=false])){-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto}:where([draggable=true]){-webkit-user-drag:element}:host,body{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body{font-weight:400}h1 sup,h2 sup,h3 sup,h4 sup,h5 sup,h6 sup{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}code{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1{font-size:2.5rem}}h2{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2{font-size:2rem}}h3{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3{font-size:1.5rem}}h4{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4{font-size:1.25rem}}h5{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5{font-size:1rem}}h6{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6{font-size:1rem}}ol li,ul li{margin-bottom:1rem}a{text-decoration:underline;color:#000;transition:color .2s}a:active,a:focus{color:#333}a:hover{color:#333}sup{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1 sup,h2 sup,h3 sup,h4 sup,h5 sup,h6 sup{font-size:max(41%,.4em)}h1 sup{top:-.35rem}h2 sup{top:-.275rem}h3 sup{top:-.2rem}h4 sup{top:-.15rem}h5 sup{top:-.1rem}table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table tr:first-child td,table tr:first-child th{border-top:none}table tr:last-child td,table tr:last-child th{border-bottom:none}table td,table th{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table th{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table th[scope=row]{text-align:left}html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}body{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body{font:-apple-system-body,sans-serif}}:host{font-size:1rem;line-height:1rem}:host :focus-visible{outline:auto 1px;outline:-webkit-focus-ring-color auto 1px}:host body{-webkit-font-smoothing:antialiased}.header{display:flex;align-items:center;justify-content:space-between;background:#000;color:#fff;padding:0 1.5rem}@media screen and (max-width: 1200px){.header{flex-direction:column-reverse;align-items:center;padding:0}}.logo{width:264px;align-items:left}@media screen and (max-width: 1200px){.logo{width:auto;position:absolute;left:50%;top:0;padding:0;transform:translate(-50%)}}.nav{align-items:center}@media screen and (max-width: 1200px){.nav{width:100%;border-top:1px solid #666}}@media screen and (max-width: 1024px){.nav{display:none}}.mobile-nav{display:none;padding-top:1.5rem;padding-bottom:1.5rem}@media screen and (max-width: 1024px){.mobile-nav{display:revert;padding-top:revert;padding-bottom:revert}}.top-content{display:flex;margin-top:auto;margin-bottom:auto;width:264px;justify-content:flex-end}@media screen and (max-width: 1200px){.top-content{width:100%}}@media screen and (max-width: 1024px){.top-content{margin-left:0;width:100%}}@media screen and (max-width: 1024px){.utility-bar{margin-left:auto}}\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n"],
        encapsulation: 3
      });
    }
  }
  return HeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const footerConfiguration = {
  categories: [{
    name: 'Contact Us',
    links: [{
      name: 'Aviation Product Support',
      link: 'aviation-support',
      site: 'FG'
    }, {
      name: 'Report a Security Issue',
      link: 'https://www.garmin.com/en-US/legal/security'
    }]
  }, {
    name: 'Databases',
    links: [{
      name: 'Database Update Schedule',
      link: 'databases/schedule',
      site: 'FLY'
    }, {
      name: 'Aviation Database Declarations',
      link: 'support/type2-loa',
      site: 'FLY'
    }, {
      name: 'Database Pricing',
      link: 'support/pricing',
      site: 'FLY'
    }, {
      name: 'Database Exclusions List',
      link: 'support/type2-loa',
      site: 'FLY'
    }, {
      name: 'Type 2 LOA Status',
      link: 'support/type2-loa',
      site: 'FLY'
    }, {
      name: 'Report a Database Error',
      link: 'https://supportforms.garmin.com/form/report-aviation-database-error/'
    }]
  }, {
    name: 'Training',
    links: [{
      name: 'Aviation Seminars and Webinars',
      link: 'https://www.garmin.com/aviationevents'
    }, {
      name: 'Tutorial Videos',
      link: 'https://www.youtube.com/garminaviation'
    }]
  }, {
    name: 'Products',
    links: [{
      name: 'Aviation Products',
      link: 'https://buy.garmin.com/en-US/US/cInTheAir-p1.html'
    }, {
      name: 'Aviation Alerts and Advisories',
      link: 'https://support.garmin.com/en-US/aviation/issue/?issueTagName=region_avserviceliterature'
    }]
  }, {
    name: 'Other',
    links: [{
      name: 'Dealer Resource Center',
      link: 'http://dealers.garmin.com/drc/index.jspx'
    }]
  }]
};
let FooterConfigurationService = /*#__PURE__*/(() => {
  class FooterConfigurationService {
    constructor() {
      this.footerConfiguration = footerConfiguration;
    }
    getFooterConfiguration() {
      return this.footerConfiguration;
    }
    static {
      this.ɵfac = function FooterConfigurationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FooterConfigurationService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FooterConfigurationService,
        factory: FooterConfigurationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FooterConfigurationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocaleService = /*#__PURE__*/(() => {
  class LocaleService {
    constructor(http, garminGlobalStoreService) {
      this.http = http;
      this.garminGlobalStoreService = garminGlobalStoreService;
      this.DIGITAL_STORE = {
        locale: 'en_XS',
        wpcLocale: 'en_US',
        wlcLocale: 'en-US',
        storeURL: '/en-US/digital',
        localeName: 'Other Countries',
        region: 'Other',
        cssClassName: null,
        wpcSupported: true,
        showInShortList: true,
        store: 'digital',
        countryName: 'All Other Countries'
      };
      this.PREFERRED_DEFAULT_STORE = this.DIGITAL_STORE;
      this.FLY_LOCALE_URL = 'https://static.garmincdn.com/apps/fly/locales/fly-locales.json';
      this.getLocales();
    }
    getLocales() {
      if (this.cache != null) {
        return of(this.cache);
      }
      return this.load();
    }
    flyLocale(desiredLocale) {
      return this.getLocales().pipe(map(locales => {
        let foundLocale = locales.find(locale => locale.locale === desiredLocale);
        if (foundLocale == null) {
          const splitIndex = desiredLocale.indexOf('-');
          const countryCode = splitIndex !== -1 ? desiredLocale.substring(splitIndex + 1) : desiredLocale;
          foundLocale = locales.find(locale => {
            const storeSplitIndex = locale.locale.indexOf('-') + 1;
            return countryCode === locale.locale.substring(storeSplitIndex);
          });
        }
        if (foundLocale == null) {
          foundLocale = this.PREFERRED_DEFAULT_STORE;
        }
        return foundLocale;
      }));
    }
    getSelectedLocale(detectedLocale = null, detectedCountry = null) {
      const localeValue = this.garminGlobalStoreService.getGlobal('locale');
      if (localeValue != null && typeof localeValue === 'string') {
        return this.flyLocale(localeValue);
      } else if (detectedLocale != null) {
        return this.flyLocale(detectedLocale);
      } else if (detectedCountry != null) {
        return this.flyLocale(detectedCountry);
      } else {
        return this.flyLocale('en-US');
      }
    }
    load() {
      return this.http.get(this.FLY_LOCALE_URL, {}).pipe(tap(content => this.cache = content));
    }
    static {
      this.ɵfac = function LocaleService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LocaleService)(i0.ɵɵinject(i1$1.HttpClient), i0.ɵɵinject(i2$2.GarminGlobalStoreService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LocaleService,
        factory: LocaleService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return LocaleService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FooterCategoryComponent = /*#__PURE__*/(() => {
  class FooterCategoryComponent {
    constructor(config) {
      this.config = config;
      this.ssoClientId = '';
      this.ssoClientId = config.ssoClientId;
    }
    static {
      this.ɵfac = function FooterCategoryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FooterCategoryComponent)(i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FooterCategoryComponent,
        selectors: [["fly-footer-category"]],
        inputs: {
          category: "category"
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [["useRouterLink", ""], ["useHrefLink", ""], ["class", "categories", 4, "ngIf"], [1, "categories"], [1, "heading"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "link", 3, "routerLink"], [1, "link", 3, "href"]],
        template: function FooterCategoryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, FooterCategoryComponent_ul_0_Template, 4, 2, "ul", 2);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.category != null);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2$1.RouterLink, HrefLinkPipe],
        styles: ["*:where(:not(html,iframe,canvas,img,svg,video,audio):not(svg *,symbol *)){all:unset;display:revert}*,*:before,*:after{box-sizing:border-box}a,button{cursor:revert}ol,ul,menu{list-style:none}img{max-width:100%}table{border-collapse:collapse}input,textarea{-webkit-user-select:auto}textarea{white-space:revert}meter{-webkit-appearance:revert;appearance:revert}::placeholder{color:unset}:where([hidden]){display:none}:where([contenteditable]:not([contenteditable=false])){-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto}:where([draggable=true]){-webkit-user-drag:element}body{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body{font-weight:400}h1 sup,h2 sup,h3 sup,h4 sup,h5 sup,h6 sup{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}code{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1{font-size:2.5rem}}h2{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2{font-size:2rem}}h3{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3{font-size:1.5rem}}h4{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4{font-size:1.25rem}}h5{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5{font-size:1rem}}h6{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6{font-size:1rem}}ol li,ul li{margin-bottom:1rem}a{text-decoration:underline;color:#000;transition:color .2s}a:active,a:focus{color:#333}a:hover{color:#333}sup{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1 sup,h2 sup,h3 sup,h4 sup,h5 sup,h6 sup{font-size:max(41%,.4em)}h1 sup{top:-.35rem}h2 sup{top:-.275rem}h3 sup{top:-.2rem}h4 sup{top:-.15rem}h5 sup{top:-.1rem}table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table tr:first-child td,table tr:first-child th{border-top:none}table tr:last-child td,table tr:last-child th{border-bottom:none}table td,table th{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table th{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table th[scope=row]{text-align:left}html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}body{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body{font:-apple-system-body,sans-serif}}.heading{font-family:Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:2rem;font-size:1.25rem;text-transform:uppercase}.categories>ul{margin:0;padding:0}.categories>ul li{list-style:none;padding:0;margin:0;padding-bottom:.5rem}.link{color:#fff;text-decoration:none}.link:hover,.link:focus,.link:active{color:#fff;text-decoration:underline}\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n"],
        encapsulation: 3
      });
    }
  }
  return FooterCategoryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MobileFooterCategoryComponent = /*#__PURE__*/(() => {
  class MobileFooterCategoryComponent {
    constructor(config) {
      this.config = config;
      this.open = false;
      this.ssoClientId = '';
      this.ssoClientId = config.ssoClientId;
    }
    onDropdownHeaderClick() {
      this.open = !this.open;
    }
    static {
      this.ɵfac = function MobileFooterCategoryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MobileFooterCategoryComponent)(i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MobileFooterCategoryComponent,
        selectors: [["fly-mobile-footer-category"]],
        inputs: {
          category: "category",
          enableTopBorder: "enableTopBorder"
        },
        standalone: false,
        decls: 11,
        vars: 8,
        consts: [["up", ""], ["down", ""], ["useRouterLink", ""], ["useHrefLink", ""], [1, "category-wrapper"], ["tabindex", "0", 1, "category-heading", 3, "click", "keydown.enter"], [1, "name"], [3, "ngTemplateOutlet", 4, "ngIf"], ["class", "e", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "height", "16", "width", "16", "fill", "#ffffff", "viewBox", "0 0 16 16", 1, "bi", "bi-chevron-up"], ["fill-rule", "evenodd", "d", "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"], ["xmlns", "http://www.w3.org/2000/svg", "height", "16", "width", "16", "fill", "#ffffff", "viewBox", "0 0 16 16", 1, "bi", "bi-chevron-down"], ["fill-rule", "evenodd", "d", "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"], [3, "ngTemplateOutlet"], [1, "e"], [4, "ngFor", "ngForOf"], [4, "ngIf", "ngIfThen", "ngIfElse"], [1, "link", 3, "routerLink"], [1, "link", 3, "href"]],
        template: function MobileFooterCategoryComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, MobileFooterCategoryComponent_ng_template_0_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, MobileFooterCategoryComponent_ng_template_2_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
            i0.ɵɵlistener("click", function MobileFooterCategoryComponent_Template_div_click_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDropdownHeaderClick());
            })("keydown.enter", function MobileFooterCategoryComponent_Template_div_keydown_enter_5_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onDropdownHeaderClick());
            });
            i0.ɵɵelementStart(6, "span", 6);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, MobileFooterCategoryComponent_ng_container_8_Template, 1, 1, "ng-container", 7)(9, MobileFooterCategoryComponent_ng_container_9_Template, 1, 1, "ng-container", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, MobileFooterCategoryComponent_ng_container_10_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(4);
            i0.ɵɵclassProp("bordered", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("bordered", ctx.enableTopBorder === true && ctx.open);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.category == null ? null : ctx.category.name);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.open);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.open);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i2$1.RouterLink, HrefLinkPipe],
        styles: ["body[_ngcontent-%COMP%]{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body[_ngcontent-%COMP%]{font-weight:400}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html[_ngcontent-%COMP%]{line-height:1.15;-webkit-text-size-adjust:100%}body[_ngcontent-%COMP%]{margin:0}main[_ngcontent-%COMP%]{display:block}h1[_ngcontent-%COMP%]{font-size:2em;margin:.67em 0}hr[_ngcontent-%COMP%]{box-sizing:content-box;height:0;overflow:visible}pre[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}a[_ngcontent-%COMP%]{background-color:transparent}abbr[title][_ngcontent-%COMP%]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b[_ngcontent-%COMP%], strong[_ngcontent-%COMP%]{font-weight:bolder}code[_ngcontent-%COMP%], kbd[_ngcontent-%COMP%], samp[_ngcontent-%COMP%]{font-family:monospace,monospace;font-size:1em}small[_ngcontent-%COMP%]{font-size:80%}sub[_ngcontent-%COMP%], sup[_ngcontent-%COMP%]{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub[_ngcontent-%COMP%]{bottom:-.25em}sup[_ngcontent-%COMP%]{top:-.5em}img[_ngcontent-%COMP%]{border-style:none}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%], optgroup[_ngcontent-%COMP%], select[_ngcontent-%COMP%], textarea[_ngcontent-%COMP%]{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button[_ngcontent-%COMP%], input[_ngcontent-%COMP%]{overflow:visible}button[_ngcontent-%COMP%], select[_ngcontent-%COMP%]{text-transform:none}button[_ngcontent-%COMP%], [type=button][_ngcontent-%COMP%], [type=reset][_ngcontent-%COMP%], [type=submit][_ngcontent-%COMP%]{-webkit-appearance:button}button[_ngcontent-%COMP%]::-moz-focus-inner, [type=button][_ngcontent-%COMP%]::-moz-focus-inner, [type=reset][_ngcontent-%COMP%]::-moz-focus-inner, [type=submit][_ngcontent-%COMP%]::-moz-focus-inner{border-style:none;padding:0}button[_ngcontent-%COMP%]:-moz-focusring, [type=button][_ngcontent-%COMP%]:-moz-focusring, [type=reset][_ngcontent-%COMP%]:-moz-focusring, [type=submit][_ngcontent-%COMP%]:-moz-focusring{outline:1px dotted ButtonText}fieldset[_ngcontent-%COMP%]{padding:.35em .75em .625em}legend[_ngcontent-%COMP%]{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress[_ngcontent-%COMP%]{vertical-align:baseline}textarea[_ngcontent-%COMP%]{overflow:auto}[type=checkbox][_ngcontent-%COMP%], [type=radio][_ngcontent-%COMP%]{box-sizing:border-box;padding:0}[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, [type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{height:auto}[type=search][_ngcontent-%COMP%]{-webkit-appearance:textfield;outline-offset:-2px}[type=search][_ngcontent-%COMP%]::-webkit-search-decoration{-webkit-appearance:none}[_ngcontent-%COMP%]::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details[_ngcontent-%COMP%]{display:block}summary[_ngcontent-%COMP%]{display:list-item}template[_ngcontent-%COMP%]{display:none}[hidden][_ngcontent-%COMP%]{display:none}code[_ngcontent-%COMP%]{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1[_ngcontent-%COMP%]{font-size:2.5rem}}h2[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2[_ngcontent-%COMP%]{font-size:2rem}}h3[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3[_ngcontent-%COMP%]{font-size:1.5rem}}h4[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4[_ngcontent-%COMP%]{font-size:1.25rem}}h5[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5[_ngcontent-%COMP%]{font-size:1rem}}h6[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6[_ngcontent-%COMP%]{font-size:1rem}}ol[_ngcontent-%COMP%]   li[_ngcontent-%COMP%], ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{margin-bottom:1rem}a[_ngcontent-%COMP%]{text-decoration:underline;color:#000;transition:color .2s}a[_ngcontent-%COMP%]:active, a[_ngcontent-%COMP%]:focus{color:#333}a[_ngcontent-%COMP%]:hover{color:#333}sup[_ngcontent-%COMP%]{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{font-size:max(41%,.4em)}h1[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.35rem}h2[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.275rem}h3[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.2rem}h4[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.15rem}h5[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{top:-.1rem}table[_ngcontent-%COMP%]{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:first-child   th[_ngcontent-%COMP%]{border-top:none}table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   tr[_ngcontent-%COMP%]:last-child   th[_ngcontent-%COMP%]{border-bottom:none}table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table[_ngcontent-%COMP%]   th[scope=row][_ngcontent-%COMP%]{text-align:left}html[_ngcontent-%COMP%]{box-sizing:border-box}*[_ngcontent-%COMP%], *[_ngcontent-%COMP%]:before, *[_ngcontent-%COMP%]:after{box-sizing:inherit}body[_ngcontent-%COMP%]{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body[_ngcontent-%COMP%]{font:-apple-system-body,sans-serif}}.category-wrapper.bordered[_ngcontent-%COMP%]{border-bottom:1px solid #fff}.category-heading[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;padding:.5rem 0;border-bottom:1px solid #000;font-family:Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:2rem;font-size:1.25rem;text-transform:uppercase;cursor:auto}.category-heading.bordered[_ngcontent-%COMP%]{border-top:1px solid #fff}.category-heading[_ngcontent-%COMP%]:hover{cursor:pointer}.category-heading[_ngcontent-%COMP%]:focus{text-decoration:underline}.category-heading[_ngcontent-%COMP%]   .name[_ngcontent-%COMP%]{display:flex;align-items:center}.link-container[_ngcontent-%COMP%]{text-align:left}.link[_ngcontent-%COMP%]{display:block;padding:.875rem 2rem;font-size:.8125rem;letter-spacing:.04rem;line-height:1.25;color:#fff;text-decoration:none}.link[_ngcontent-%COMP%]:hover, .link[_ngcontent-%COMP%]:focus, .link[_ngcontent-%COMP%]:active{color:#fff;text-decoration:underline}\n\n"]
      });
    }
  }
  return MobileFooterCategoryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FooterComponent = /*#__PURE__*/(() => {
  class FooterComponent {
    constructor(config, footerConfigurationService, localeService) {
      this.config = config;
      this.footerConfigurationService = footerConfigurationService;
      this.localeService = localeService;
      this.flyGarminVersion = null;
      this.detectedLocale = null;
      this.detectedCountry = null;
      // FIXME: `loggedIn` isn't used anywhere in the footer...
      this.loggedIn = null;
      this.localeName = null;
    }
    ngOnChanges() {
      this.localeService.getSelectedLocale(this.detectedLocale, this.detectedCountry).subscribe(locale => {
        this.localeName = locale.localeName;
      });
    }
    changeLocale() {
      // The below url needs updated to point to the fg select-locale page when fg is live
      const localeUrl = `${this.config.fgUrl}select-locale?returnTo=${window.location.href}`;
      window.location.href = localeUrl;
    }
    static {
      this.ɵfac = function FooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FooterComponent)(i0.ɵɵdirectiveInject(FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN), i0.ɵɵdirectiveInject(FooterConfigurationService), i0.ɵɵdirectiveInject(LocaleService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FooterComponent,
        selectors: [["fly-footer"]],
        inputs: {
          flyGarminVersion: "flyGarminVersion",
          detectedLocale: "detectedLocale",
          detectedCountry: "detectedCountry",
          loggedIn: "loggedIn"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 18,
        vars: 4,
        consts: [[1, "footer"], [1, "footer-categories"], [3, "category", 4, "ngFor", "ngForOf"], [1, "mobile-footer-categories"], ["class", "locale", 4, "ngIf"], [1, "legalese"], [1, "copyright"], ["class", "fly-version", 3, "innerHTML", 4, "ngIf"], [1, "legal-links"], ["href", "https://www.garmin.com/en-US/legal/terms-of-use/", 1, "link"], ["href", "https://www.garmin.com/en-US/privacy/aviation/", 1, "link"], [3, "category"], [1, "locale"], ["tabindex", "0", 1, "link", 3, "click"], [1, "fly-version", 3, "innerHTML"]],
        template: function FooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, FooterComponent_fly_footer_category_2_Template, 1, 1, "fly-footer-category", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtemplate(4, FooterComponent_fly_mobile_footer_category_4_Template, 1, 1, "fly-mobile-footer-category", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, FooterComponent_div_5_Template, 3, 1, "div", 4);
            i0.ɵɵelementStart(6, "div", 5)(7, "div", 6);
            i0.ɵɵtext(8, " \xA9 Garmin Ltd. or its subsidiaries. All rights reserved. ");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, FooterComponent_div_9_Template, 1, 1, "div", 7);
            i0.ɵɵelementStart(10, "div", 8)(11, "ul")(12, "li")(13, "a", 9);
            i0.ɵɵtext(14, " Terms of Use ");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(15, "li")(16, "a", 10);
            i0.ɵɵtext(17, " Privacy Policy ");
            i0.ɵɵelementEnd()()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.footerConfigurationService.getFooterConfiguration().categories);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.footerConfigurationService.getFooterConfiguration().categories);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.localeName != null);
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.flyGarminVersion != null);
          }
        },
        dependencies: [i2.NgForOf, i2.NgIf, FooterCategoryComponent, MobileFooterCategoryComponent],
        styles: ["*:where(:not(html,iframe,canvas,img,svg,video,audio):not(svg *,symbol *)){all:unset;display:revert}*,*:before,*:after{box-sizing:border-box}a,button{cursor:revert}ol,ul,menu{list-style:none}img{max-width:100%}table{border-collapse:collapse}input,textarea{-webkit-user-select:auto}textarea{white-space:revert}meter{-webkit-appearance:revert;appearance:revert}::placeholder{color:unset}:where([hidden]){display:none}:where([contenteditable]:not([contenteditable=false])){-moz-user-modify:read-write;-webkit-user-modify:read-write;overflow-wrap:break-word;-webkit-line-break:after-white-space;-webkit-user-select:auto}:where([draggable=true]){-webkit-user-drag:element}body{font-family:Superscripts-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}sup{font-family:Superscripts-InsideSup-Roboto,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}body{font-weight:400}h1 sup,h2 sup,h3 sup,h4 sup,h5 sup,h6 sup{font-family:Superscripts-InsideSup-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif}html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}code{font-family:monospace,serif;background:#f2f2f2;border:1px solid rgb(216.75,216.75,216.75);padding:.25em;border-radius:.25em;font-size:.875rem}h1{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:2rem;margin:1rem 0}@media screen and (min-width: 768px){h1{font-size:2.5rem}}h2{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.5rem;margin:1rem 0}@media screen and (min-width: 768px){h2{font-size:2rem}}h3{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1.25rem;margin:1rem 0}@media screen and (min-width: 768px){h3{font-size:1.5rem}}h4{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:1rem;margin:1rem 0}@media screen and (min-width: 768px){h4{font-size:1.25rem}}h5{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h5{font-size:1rem}}h6{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;line-height:1.25;font-size:.875rem;margin:1rem 0}@media screen and (min-width: 768px){h6{font-size:1rem}}ol li,ul li{margin-bottom:1rem}a{text-decoration:underline;color:#000;transition:color .2s}a:active,a:focus{color:#333}a:hover{color:#333}sup{font-size:max(52%,.4em);line-height:1;position:relative;top:0;vertical-align:super}h1 sup,h2 sup,h3 sup,h4 sup,h5 sup,h6 sup{font-size:max(41%,.4em)}h1 sup{top:-.35rem}h2 sup{top:-.275rem}h3 sup{top:-.2rem}h4 sup{top:-.15rem}h5 sup{top:-.1rem}table{width:100%;border-collapse:collapse;table-layout:fixed;font-size:1rem;border:none}table tr:first-child td,table tr:first-child th{border-top:none}table tr:last-child td,table tr:last-child th{border-bottom:none}table td,table th{border:1px solid rgb(216.75,216.75,216.75);border-left:0;border-right:0;padding:1rem;vertical-align:top;text-align:center}table th{font-family:Superscripts-Oswald,Oswald,Roboto Condensed,Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-weight:400;letter-spacing:.05rem;text-transform:uppercase}table th[scope=row]{text-align:left}html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}body{font-size:16px;line-height:1.5;margin:0}@supports (font: -apple-system-body){body{font:-apple-system-body,sans-serif}}.footer{background:#000;color:#fff;width:100%;font-family:Roboto,Noto Sans TC,Noto Sans SC,Noto Sans JP,Noto Sans KR,Prompt,sans-serif;font-size:.8rem;font-weight:500;margin-top:3rem}.footer-categories{display:flex;align-items:flex-start;justify-content:space-between;flex-wrap:wrap;flex:1 1 100%;margin:0 4.5rem;padding:1.5rem 0}@media screen and (max-width: 1200px){.footer-categories{display:none}}.mobile-footer-categories{display:none}@media screen and (max-width: 1200px){.mobile-footer-categories{padding:1.5rem;display:block}}.legalese{display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;flex:1 1 100%;margin:0 1.5rem;border-top:#fff solid 4px;padding:1.5rem 0}@media screen and (max-width: 1200px){.legalese{flex-direction:column-reverse;align-items:center;padding:auto}}.locale{text-align:left;padding-top:1rem;padding-left:1.5rem;padding-right:1.5rem;margin-bottom:1rem}@media screen and (max-width: 1200px){.locale{padding-top:1rem;text-align:center}}.fly-version{color:#000}@media screen and (max-width: 1200px){.fly-version{display:none}}.legal-links>ul{margin:0;text-align:center;display:flex;flex-wrap:wrap;align-items:center;justify-content:center;padding:0;margin-right:-1rem}@media screen and (max-width: 1200px){.legal-links>ul{padding-top:1rem;padding-bottom:1rem;margin:0}}.legal-links>ul li{list-style:none;padding:0;margin:0 1rem}.link{color:#fff;text-decoration:none;cursor:pointer}.link:hover,.link:focus,.link:active{color:#fff;text-decoration:underline}\n/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n"],
        encapsulation: 3
      });
    }
  }
  return FooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FlyGarminAppNavigationModule = /*#__PURE__*/(() => {
  class FlyGarminAppNavigationModule {
    static {
      this.ɵfac = function FlyGarminAppNavigationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FlyGarminAppNavigationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: FlyGarminAppNavigationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule]
      });
    }
  }
  return FlyGarminAppNavigationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FlyGarminAppNavigationService = /*#__PURE__*/(() => {
  class FlyGarminAppNavigationService {
    constructor(injector) {
      this.injector = injector;
    }
    exportComponents() {
      const components = [['fly-footer', FooterComponent], ['fly-footer-category', FooterCategoryComponent], ['fly-mobile-footer-category', MobileFooterCategoryComponent], ['fly-header', HeaderComponent], ['fly-header-logo', HeaderLogoComponent], ['fly-header-nav-area', HeaderNavAreaComponent], ['fly-header-nav', HeaderNavComponent], ['fly-header-nav-menu', HeaderNavMenuComponent], ['fly-header-skip-navigation', HeaderSkipNavigationComponent], ['fly-header-utility-bar', HeaderUtilityBarComponent], ['fly-mobile-nav-category', MobileNavCategoryComponent], ['fly-mobile-nav', MobileNavComponent], ['fly-mobile-nav-icon', MobileNavIconComponent], ['fly-mobile-nav-open', MobileNavOpenComponent], ['fly-mobile-nav-subcategory', MobileNavSubcategoryComponent]];
      for (const [name, type] of components) {
        /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
        const el = createCustomElement(type, {
          injector: this.injector
        });
        customElements.define(name, el);
      }
    }
    static {
      this.ɵfac = function FlyGarminAppNavigationService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FlyGarminAppNavigationService)(i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FlyGarminAppNavigationService,
        factory: FlyGarminAppNavigationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FlyGarminAppNavigationService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of fly-garmin-app-navigation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FLY_GARMIN_APP_NAVIGATION_CONFIG_TOKEN, FlyGarminAppNavigationModule, FlyGarminAppNavigationService, FooterComponent, HeaderCartService, HeaderComponent, HeaderConfigurationService };
